<template>
<div id="purchase_order_create" class="fleet-form-main">
    <div :class="`loader${loaderClass}`" v-show="loading">
    </div>
    <div id="page-content-wrapper" class="admin-content-area">
        <template v-if="cantAccessPage === true">
            <div class="page-name">
                <span class="page-title" id="purchaseorderHeader" v-if="$route.params.id > 0">Update Vendor Purchase Order</span>
                <span class="page-title" id="purchaseorderHeader" v-else>Add Vendor Purchase Order</span>
                <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="PurchaseOrderList">
                    <i class="fp-back"> </i> Back
                </button>
            </div>
            <div class="container-fluid">
                <div class="admin-page-content purchase-order-crud">
                    <section class="internal-container border-top-table-fl">
                        <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="PurchaseOrderForm">
                            <div class="form-row row-cols-md-4 row-cols-1">
                                <!-- <div v-if="$route.params.id > 0" class="col form-group pt-3">
                                    <label class="control-label label" for="name">PO Number:</label>
                                    <label class="control-label">{{po_number}}</label>
                                </div> -->
                                <div v-if="$route.params.id > 0 || !conTypeDisable" class="col form-group">
                                    <label class="control-label require" for="period">PO Number:</label>
                                    <input type="text" :disabled="conTypeDisable" class="form-control" v-model="po_number" id="po_number" placeholder="PO Number" name="po_number">
                                    <div class="field-error">{{ po_number_error_msg }}</div>
                                </div>
                                <div class="col form-group">
                                    <label class="control-label require" for="purchase_order_type">Purchase Order Type:</label>
                                    <v-select id="purchase_order_type" v-model="purchase_order_type" @input="changePOType" name="purchase_order_type" placeholder="Select Purchase Order Type." label="text" class="close-remove" :options="purchaseOrderTypesArr" :disabled="disablePurchaseOrderTypeField">
                                    </v-select>
                                    <div class="field-error">{{ purchase_order_type_error_msg }}</div>
                                </div>
                                <!-- <div class="col form-group">
                                    <label class="control-label require" for="status">Status:</label>
                                    <v-select class="close-remove" v-model="status" name="status" placeholder="Select Status." label="text" :options="statusArr">
                                    </v-select>
                                    <div class="field-error">{{status_error_msg}}</div>
                                </div> -->
                                <div class="col form-group">
                                    <label class="control-label require" for="vendor_id">Vendor:</label>
                                    <v-select v-model="vendor_id" name="vendor_id" label="text" :filterable="false" :options="vendorArr" @search="onSearchVendor" placeholder="Select Vendor Code or Name" class="custom-ci-auto-search">
                                        <template slot="no-options">
                                            Search Vendor Code or Name...
                                        </template>
                                        <template slot="option" slot-scope="option">
                                            <div class="d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                        <template slot="selected-option" slot-scope="option">
                                            <div class="selected d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                    </v-select>
                                    <div class="field-error">{{ vendor_error_msg }}</div>
                                </div>
                                <div class="col form-group">
                                    <label class="control-label require" for="ordering_location_id">Ordering Location:</label>
                                    <v-select v-model="ordering_location_id" name="ordering_location_id" placeholder="Select Location." label="text" :options="locationArr">
                                    </v-select>
                                    <div class="field-error">{{ ordering_location_error_msg }}</div>
                                </div>
                                <div class="col form-group">
                                    <label class="control-label require" for="assigned_location_id">Assigned Location:</label>
                                    <v-select v-model="assigned_location_id" name="assigned_location_id" placeholder="Select Location." label="text" :options="locationArr">
                                    </v-select>
                                    <div class="field-error">{{ assigned_location_error_msg }}</div>
                                </div>
                                <div class="col form-group">
                                    <label class="control-label require" for="ship_to_location_id">Ship To Location:</label>
                                    <v-select v-model="ship_to_location_id" name="ship_to_location_id" placeholder="Select Location." label="text" :options="locationArr">
                                    </v-select>
                                    <div class="field-error">{{ ship_to_location_error_msg }}</div>
                                </div>
                                <div class="col form-group">
                                    <label class="control-label require" for="order_date">Order Date:</label>
                                    <div class="input-group">
                                        <date-picker placeholder="MM/DD/YYYY" id="order_date" name="order_date" v-model="order_date" :config="optionsDate"></date-picker>
                                        <label for="order_date" class="fp-calendar input-calender-icon"></label>
                                    </div>
                                    <div class="field-error">{{ order_date_error_msg }}</div>
                                </div>
                                <div class="col form-group">
                                    <label class="control-label" for="delivery_date">Delivery Date:</label>
                                    <div class="input-group">
                                        <date-picker placeholder="MM/DD/YYYY" id="delivery_date" name="delivery_date" v-model="delivery_date" :config="optionsDate"></date-picker>
                                        <label for="delivery_date" class="fp-calendar input-calender-icon"></label>
                                    </div>
                                    <div class="field-error">{{ delivery_date_error_msg }}</div>
                                </div>
                                <div class="col form-group" v-if="(purchase_order_type.value == 'equipment' || purchase_order_type.value == 'sublet_po')">
                                    <label class="control-label" for="period">Attention:</label>
                                    <input type="text" class="form-control" v-model="attention" id="attention" placeholder="Enter Attention (If any)" name="attention">
                                    <div class="field-error"></div>
                                </div>
                                <!-- <div class="col form-group" v-if="(purchase_order_type.value == 'equipment' || purchase_order_type.value == 'sublet_po')">
                                    <label class="control-label" for="vendor_id">Sales Person:</label>
                                    <v-select v-model="sales_person_id" name="sales_person_id" id="sales_person_id" label="text" :filterable="false" :options="userArr" @search="onSearchUser" placeholder="Select User" class="custom-ci-auto-search contract-data">
                                        <template slot="no-options">
                                            Search User...
                                        </template>
                                        <template slot="option" slot-scope="option">
                                            <div class="d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                        <template slot="selected-option" slot-scope="option">
                                            <div class="selected d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                    </v-select>
                                    <div class="field-error">{{ sales_person_error_msg }}</div>
                                </div> -->
                                <div class="col form-group" v-if="(purchase_order_type.value == 'equipment' || purchase_order_type.value == 'sublet_po')">
                                    <label class="control-label" for="period">Amount:</label>
                                    <input type="text" class="form-control" v-model="amount"
                                    id="attention" placeholder="Enter Amount" name="amount"
                                    @keypress="isAmountCheck($event, true, 9999999)"
                                    @blur="amount = leaveFocus($event)"
                                    @focus="amount = enterVal($event)">
                                    <div class="field-error">{{wo_amount_error_msg}}</div>
                                </div>
                                <!-- <div class="col form-group" v-if="(purchase_order_type.value == 'item' || purchase_order_type.value == 'misc')">
                                    <label class="control-label" for="period">#Vendor Invoice:</label>
                                    <input type="text" class="form-control" v-model="bill_number" id="bill_number" placeholder="Enter Invoice Number" name="bill_number">
                                    <div class="field-error">{{wo_amount_error_msg}}</div>
                                </div> -->
                            </div>
                            <div class="form-row row-cols-md-2 row-cols-1">
                                <div class="col form-group">
                                    <label class="control-label" for="period">Notes:</label>
                                    <textarea class="form-control" v-model="notes" id="attention" placeholder="Enter Notes" name="Notes" rows="4">
                                    </textarea>
                                    <div class="field-error">{{notes_error_msg}}</div>
                                </div>
                            </div>

                            <template v-if="purchase_order_type.value == 'equipment-osr'">
                                <hr class="light-hr"/>
                                <h5 class="section-title"> Unit Information </h5>
                                <div class="form-row row-cols-md-4 row-cols-1">

                                    <div class="col form-group">
                                        <label class="control-label require" for="vin">Unit:</label>
                                        <input type="text" class="form-control" v-model="unit" id="unit" placeholder="Enter Unit" name="unit">
                                        <div class="field-error">{{unit_error_msg}}</div>
                                    </div>

                                    <div class="col form-group">
                                        <label class="control-label" for="vin">Vendor Unit #:</label>
                                        <input type="text" class="form-control" v-model="vendorUnit" id="vendor_unit" placeholder="Enter Vendor Unit Number" name="vendor_unit">
                                        <div class="field-error">{{vendorUnit_error_msg}}</div>
                                    </div>

                                    <div class="col form-group">
                                        <label class="control-label require" for="vin">VIN:</label>
                                        <input type="text" class="form-control" v-model="vin" id="code" placeholder="Enter Serial" name="vin">
                                        <div class="field-error">{{vin_error_msg}}</div>
                                    </div>

                                    <div class="col form-group">
                                        <label class="control-label" for="period">Attention:</label>
                                        <input type="text" class="form-control" v-model="attention" id="attention" placeholder="Enter Attention (If any)" name="attention">
                                        <div class="field-error"></div>
                                    </div>

                                    <div class="col form-group">
                                        <label class="control-label require" for="vin">Pool:</label>
                                        <v-select class="close-remove" v-model="osr_asset_pool" name="asset_pool_id" placeholder="Select Asset Pool." label="text" :options="assetPoolArr">
                                        </v-select>
                                        <div class="field-error">{{osr_asset_pool_error_msg}}</div>
                                    </div>

                                    <div class="col form-group">
                                        <label class="control-label require" for="vin">Equipment Type:</label>
                                        <v-select v-model="vehicle_type" name="vehicle_type"
                                        placeholder="Select Asset Type."
                                                    label="text"
                                                    :options="vehicleTypeArr">
                                        </v-select>
                                        <div class="field-error">{{vehicle_type_error_msg}}</div>
                                    </div>

                                    <div class="col form-group">
                                        <label class="control-label" for="vehicle_manufacturer_id">Manufacturer:</label>
                                        <v-select v-model="vehicle_manufacturer_id" name="vehicle_manufacturer_id" placeholder="Select Manufacturer."
                                                label="text"
                                                :options="vehicleManufacturerArr">
                                        </v-select>
                                        <div class="field-error"></div>
                                    </div>

                                    <div class="col form-group">
                                        <label class="control-label" for="vehicle_model_id">Model:</label>
                                        <v-select v-model="vehicle_model_id" name="vehicle_model_id" placeholder="Select Model."
                                                label="text"
                                                :options="modelArr">
                                        </v-select>
                                        <div class="field-error"></div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="year">Year:</label>
                                        <input type="text" class="form-control" v-model="year" id="year" placeholder="Enter Year" name="year" @keypress="isIntegerCheck($event)">
                                        <div class="field-error"></div>
                                    </div>

                                    <div class="col form-group">
                                        <label class="control-label require" for="vin">Estimate Order Cost:</label>
                                        <input type="text" placeholder="Estimate Order Cost" v-model="estimate_cost"
                                        @keypress="isAmountCheck($event)"
                                        @blur="estimate_cost = leaveFocus($event)"
                                        @focus="estimate_cost = enterVal($event)" name="estimate_cost" class="vgt-input text-right">
                                        <div class="field-error">{{estimate_cost_error_msg}}</div>
                                    </div>

                                </div>
                            </template>
                            <hr class="light-hr"/>
                            <template v-if="purchase_order_type.value == 'sublet_po'">
                                <!-- <div class="purchase-order-create-main table-responsive-sm">
                                    <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                        <thead>
                                            <tr class="table-primary">
                                                <th scope="col" class="require" style="width:400px">Type</th>
                                                <th scope="col">Description</th>
                                                <th scope="col" class="require">Amount</th>
                                                <th scope="col"> Action </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(chrow, chindex) in chrows" :key="chindex">
                                                <td>
                                                    <v-select v-model="chrow.charge_id" name="charge_id" placeholder="Select Charge."
                                                                label="text"
                                                                :options="chargesArr" @input="onChargeSelect($event,chindex)" :disabled="chrow.disableChargeSelect">
                                                    </v-select>
                                                    <div class="field-error">{{chrow.charge_type_error_msg}}</div>
                                                </td>
                                                <td>
                                                    <textarea v-model="chrow.description" name="description" placeholder="Description" class="vgt-input">
                                                    </textarea>
                                                    <div class="field-error">{{chrow.desc_error_msg}}</div>
                                                </td>
                                                <td>
                                                    <input type="text" placeholder="Amount" v-model="chrow.amount" id="amount" name="amount" class="form-control text-right"
                                                    @keypress="isNumberCheck($event,chindex, 'chrow-amount')"
                                                    @input="validateCHRowAmountInput($event,chindex)"
                                                    @blur="leaveFocusLine($event,chindex)"
                                                    @focus="enterValLine($event,chindex)"
                                                    v-on:keyup="calculateChargeAmount($event,chindex)">
                                                    <div class="field-error">{{chrow.amount_error_msg}}</div>
                                                </td>
                                                <td class="text-center valign-middle">
                                                    <template v-if="chrows.length != 1">
                                                        <template v-if="chrow.disableChargeSelect">
                                                            <span class="close-row"> _ </span>
                                                        </template>
                                                        <template v-else>
                                                            <span class="close-row"> <a href="javascript:void(0);" v-on:click="removeChargeElement(chindex);"> ×
                                                            </a></span>
                                                        </template>
                                                    </template>
                                                    <template v-else>
                                                        <span class="close-row"> _ </span>
                                                    </template>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" v-on:click.prevent="addLine()" class="btn btn-primary">
                                        <i class="fp-add"></i> Add Line Item
                                    </button>
                                </div> -->
                                <div class="purchase-order-create-main table-responsive-sm">
                                    <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                        <thead>
                                            <tr class="table-primary">
                                                <th scope="col" class="require" style="width:600px">Description</th>
                                                <th scope="col" class="require">Amount</th>
                                                <th scope="col"> Action </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(chrow, chindex) in chrows" :key="chindex">
                                                <td style="width:600px">
                                                    <textarea v-model="chrow.description" name="description" placeholder="Description" class="form-control">
                                                    </textarea>
                                                    <div class="field-error">{{chrow.desc_error_msg}}</div>
                                                </td>
                                                <td>
                                                <input type="text" placeholder="Amount" v-model="chrow.amount" id="amount" name="amount" class="form-control text-right"
                                                    @keypress="isNumberCheck($event,chindex, 'chrow-amount')"
                                                    @input="validateCHRowAmountInput($event,chindex)"
                                                    @blur="leaveFocusLine($event,chindex)"
                                                    @focus="enterValLine($event,chindex)"
                                                    v-on:keyup="calculateChargeAmount($event,chindex)" :disabled="chrow.disableChargeSelect">
                                                    <div class="field-error">{{chrow.amount_error_msg}}</div>
                                                </td>
                                                <td class="text-center valign-middle">
                                                    <template v-if="chrows.length != 1">
                                                        <template v-if="chrow.disableChargeSelect">
                                                            <span class="close-row"> _ </span>
                                                        </template>
                                                        <template v-else>
                                                            <span class="close-row"> <a href="javascript:void(0);" v-on:click="removeChargeElement(chindex);"> ×
                                                            </a></span>
                                                        </template>
                                                    </template>
                                                    <template v-else>
                                                        <span class="close-row"> _ </span>
                                                    </template>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </template>
                            <template v-else-if="purchase_order_type.value == 'equipment-osr'">
                              <div class="purchase-order-create-main form-group table-responsive-sm">
                                  <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                      <thead>
                                          <tr class="table-primary">
                                              <th scope="col" class="require">Section</th>
                                              <th scope="col" class="require">Reading Date</th>
                                              <th scope="col">Reading</th>
                                              <th scope="col"> Action </th>
                                          </tr>
                                      </thead>
                                      <tbody>
                                          <tr v-for="(row, index) in eqp_po_rows" :key="index">
                                              <td>
                                                  <v-select v-model="row.section_type" name="section_type"
                                                  id="section_type" label="text" :filterable="false" :options="sectionArr"
                                                  placeholder="Select Section"
                                                  class="custom-ci-auto-search contract-data">
                                                  </v-select>
                                                  <div class="field-error">{{row.section_type_error_msg}}</div>
                                              </td>
                                              <td>
                                                  <div class="input-group form-group mb-0">
                                                      <date-picker placeholder="MM/DD/YYYY HH:mm:ss"
                                                      id="reading_date" name="reading_date"
                                                      v-model="row.reading_date"
                                                      :config="optionsDateTime"
                                                      aria-describedby="basic-addon3"
                                                      class="cal-icon"></date-picker>
                                                      <label for="reading_date"
                                                      class="fp-calendar input-calender-icon"></label>
                                                  </div>
                                                  <!--date-picker placeholder="MM/DD/YYYY HH:mm:ss"
                                                   v-model="row.reading_date"
                                                  :config="optionsDateTime"></date-picker-->

                                                  <!--date-picker placeholder="Select Date" class="form-control"
                                                  v-model="row.reading_date" :config="optionsDateTime">
                                                  </date-picker-->
                                                  <!--flat-pickr v-model="row.reading_date" :config="config" @on-change="doSomethingOnChange" @on-close="doSomethingOnClose" class="form-control" placeholder="Select date" name="date1">
                                                  </flat-pickr-->
                                                  <!--label class="fp-calendar"></label-->
                                                  <div class="field-error">{{row.reading_date_error_msg}}</div>
                                              </td>
                                              <td>
                                                  <input type="text" placeholder="Reading" v-model="row.reading" name="reading"
                                                  @keypress="isNumberCheck($event)"
                                                   id="reading" class="form-control text-right">
                                                  <div class="field-error">{{row.reading_error_msg}}</div>
                                              </td>
                                              <td class="valign-middle" align="center" style="font-size:12px;">
                                                  <template v-if="eqp_po_rows.length != 1">
                                                      <span class="close-row"> <a href="javascript:void(0);" v-on:click="removeEqpPOReadingElement(index);"> <i class="fp-close color-red"></i></a></span>
                                                  </template>
                                                  <template v-else>
                                                      <span class="close-row"> _ </span>
                                                  </template>
                                              </td>
                                          </tr>
                                      </tbody>
                                  </table>
                                  <div class="btn-groups mt-2">
                                      <button type="submit" v-on:click.prevent="addPOReadingRow()" class="btn btn-primary">
                                          <i class="fp-add"></i> Add Line Item
                                      </button>
                                  </div>
                              </div>
                            </template>
                            <template v-else>
                              <div class="purchase-order-create-main form-group table-responsive-sm">
                                  <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                      <thead>
                                          <tr class="table-primary">
                                              <template v-if="showItemFields">
                                                  <th scope="col" class="" style="width:400px" v-if="purchase_order_type.value != 'misc'">Part</th>
                                                  <th scope="col" class="require" style="width:400px" v-if="purchase_order_type.value == 'misc'">Description</th>
                                                  <th scope="col" class="require" v-if="(purchase_order_type.value == 'equipment' || purchase_order_type.value == 'sublet_po')"> Labor </th>
                                                  <th scope="col" class="require">Qty / Hours</th>
                                              </template>
                                              <template v-else>
                                                  <th scope="col" class="require" style="width:400px">Asset Model</th>
                                                  <th scope="col" class="require" style="width:400px">Asset Pool</th>
                                                  <th scope="col" class="">Year</th>
                                                  <th scope="col" class="require">Quantity</th>
                                              </template>
                                              <th scope="col" class="require">Unit Price</th>
                                              <th scope="col">Amount</th>
                                              <th scope="col" class="col-md-1" v-if="purchase_order_type.value == 'misc'">UOM</th>
                                              <th v-if="purchase_order_type.value == 'misc'" class="require col-md-3" scope="col">GL Account</th>
                                              <th v-if="purchase_order_type.value == 'item'" class="col-md-3" scope="col">Unit No.</th>
                                              <th scope="col"> Action </th>
                                          </tr>
                                      </thead>
                                      <tbody>
                                          <tr v-for="(row, index) in rows" :key="index">
                                              <template v-if="showItemFields">
                                                  <td v-if="purchase_order_type.value != 'misc'">
                                                      <v-select v-model="row.part" name="part" id="part" label="text" :filterable="false" :options="itemArr" @search="onSearchComponent" @input="populatePrice(row.part.value,index)" placeholder="Select Part" class="custom-ci-auto-search contract-data">
                                                          <template slot="no-options">
                                                              Search Part...
                                                          </template>
                                                          <template slot="option" slot-scope="option">
                                                              <div class="d-center">
                                                                  {{ option.text }}
                                                              </div>
                                                          </template>
                                                          <template slot="selected-option" slot-scope="option">
                                                              <div class="selected d-center">
                                                                  {{ option.text }}
                                                              </div>
                                                          </template>
                                                      </v-select>
                                                      <div class="field-error">{{row.part_error_msg}}</div>
                                                  </td>
                                                  <td v-if="(purchase_order_type.value == 'equipment' || purchase_order_type.value == 'sublet_po' || purchase_order_type.value == 'misc')">
                                                      <input type="text" v-model="row.description" name="description" placeholder="Enter Detail" class="form-control">
                                                      <div class="field-error">{{row.desc_error_msg}}</div>
                                                  </td>
                                              </template>
                                              <template v-else>
                                                  <td>
                                                        <v-select v-model="row.model_code" name="model_code"
                                                        id="model_code" label="text" :filterable="false"
                                                        :options="modelcodeArr" @search="onSearchModel"
                                                        placeholder="Select Model" class="custom-ci-auto-search contract-data">
                                                            <template slot="no-options">
                                                                Search Model...
                                                            </template>
                                                            <template slot="option" slot-scope="option">
                                                                <div class="d-center">
                                                                    {{ option.text }}
                                                                </div>
                                                            </template>
                                                            <template slot="selected-option" slot-scope="option">
                                                                <div class="selected d-center">
                                                                    {{ option.text }}
                                                                </div>
                                                            </template>
                                                        </v-select>
                                                        <div class="field-error">{{row.model_error_msg}}</div>
                                                    </td>
                                                    <td>
                                                        <v-select class="close-remove" v-model="row.asset_pool_id" name="asset_pool_id" id="asset_pool_id" placeholder="Select Asset Pool." label="text" :options="assetPoolArr">
                                                        </v-select>
                                                        <div class="field-error">{{row.asset_pool_error_msg}}</div>
                                                    </td>
                                                    <td>
                                                        <input type="text" v-model="row.year" id="year" name="year" placeholder="Year" class="form-control" @keypress="isIntegerCheck($event)">
                                                        <div class="field-error">{{row.year_error_msg}}</div>
                                                    </td>
                                              </template>
                                              <td>
                                                  <template v-if="purchase_order_type.value == 'equipment'">
                                                      <input type="text" placeholder="Quantity" v-model="row.quantity" name="quantity"
                                                        @keypress="isNumberCheck($event,index,'row-qty')"
                                                        v-on:keyup="calculateAmount($event,index)" id="quantity" class="form-control text-right">
                                                  </template>
                                                  <template v-else-if="purchase_order_type.value == 'item' || purchase_order_type.value == 'misc' ">
                                                    <input type="text" placeholder="Quantity" v-model="row.quantity" name="quantity"
                                                    @keypress="isNumberOnly($event)" @blur="leaveFocusUnitPrice($event,index,'item-qty')"
                                                    v-on:keyup="calculateAmount($event,index)" id="quantity" class="form-control text-right">
                                                  </template>
                                                  <div class="field-error">{{row.quantity_error_msg}}</div>
                                              </td>
                                              <td>
                                                  <template v-if="purchase_order_type.value == 'item'">
                                                      <input type="text" placeholder="Price" v-model="row.unit_price"
                                                        @input="validateRawInput($event,index)"
                                                        v-on:keyup="calculateAmount($event,index)" @blur="leaveFocusUnitPrice($event,index,'item-price')" @focus="enterUnitPrice($event,index,'item-price')"
                                                        @keypress="isNumberCheck($event,index, 'row-price')" name="unit_price" :id="'unit_price'+index" class="form-control text-right">
                                                  </template>
                                                  <template v-else>
                                                    <input type="text" placeholder="Price" v-model="row.unit_price"
                                                    @input="validateRawInput($event,index)"
                                                    v-on:keyup="calculateAmount($event,index)"
                                                    @keypress="isNumberCheck($event,index, 'row-price')"
                                                    @blur="row.unit_price = leaveFocus($event)"
                                                    @focus="row.unit_price = enterVal($event)"
                                                    name="unit_price" class="form-control text-right" :id="'unit_price'+index">
                                                  </template>
                                                  <div class="field-error">{{row.unit_price_error_msg}}</div>
                                              </td>
                                              <td>
                                                  <input type="text" disabled placeholder="Amount" v-model="row.amount" id="amount" name="amount" class="form-control text-right">
                                              </td>
                                              <td v-if="purchase_order_type.value == 'misc'">
                                                  <v-select v-model="row.measurement_unit_id" name="unit_id" placeholder="Select UOM"
                                                    label="text"
                                                    :options="vomArr">
                                                    </v-select>
                                              </td>
                                              <td v-if="purchase_order_type.value == 'misc'">
                                                  <v-select v-model="row.gl_account_id" name="gl_account_id" id="gl_account_id" label="text" :filterable="false" :options="accountsArr" @search="onSearchAccount" placeholder="Select GL Account" class="custom-ci-auto-search contract-data">
                                                        <template slot="no-options">
                                                            Search GL Account...
                                                        </template>
                                                        <template slot="option" slot-scope="option">
                                                            <div class="d-center">
                                                                {{ option.text }}
                                                            </div>
                                                        </template>
                                                        <template slot="selected-option" slot-scope="option">
                                                            <div class="selected d-center">
                                                                {{ option.text }}
                                                            </div>
                                                        </template>
                                                    </v-select>
                                                    <div class="field-error">{{row.account_error_msg}}</div>
                                              </td>
                                              <td v-if="purchase_order_type.value == 'item'">
                                                <v-select v-model="row.vehicle_id" id="vehicle_id" name="vehicle_id" label="text" :filterable="false" :options="vehicleArr" @search="onSearchAsset" placeholder="Select Unit No." class='custom-ci-auto-search'>
                                                    <template slot="no-options">
                                                        Search Unit No...
                                                    </template>
                                                    <template slot="option" slot-scope="option">
                                                        <div class="d-center">
                                                            {{ option.text }}
                                                        </div>
                                                    </template>
                                                    <template slot="selected-option" slot-scope="option">
                                                        <div class="selected d-center">
                                                            {{ option.text }}
                                                        </div>
                                                    </template>
                                                </v-select>
                                              </td>
                                              <td class="valign-middle" align="center" style="font-size:12px;">
                                                  <template v-if="rows.length != 1">
                                                      <span class="close-row"> <a href="javascript:void(0);" v-on:click="removeElement(index);"> <i class="fp-close color-red"></i></a></span>
                                                  </template>
                                                  <template v-else>
                                                      <span class="close-row"> _ </span>
                                                  </template>
                                              </td>
                                          </tr>
                                          <!-- <template v-if="showTotalSummary">
                                              <tr>
                                                  <td colspan="4" rowspan="2"></td>
                                                  <td class="table-secondary table-title" colspan="2">Subtotal</td>
                                                  <td align="right" class="table-secondary">${{sub_total.toFixed(2)}}</td>
                                              </tr>
                                              <tr>
                                                  <td class="table-secondary table-title" colspan="2">Total</td>
                                                  <td align="right" class="table-secondary  order-total">${{total}}</td>
                                              </tr>
                                          </template> -->
                                      </tbody>
                                  </table>
                                  <div class="btn-groups mt-2">
                                      <button type="submit" v-on:click.prevent="addRow()" class="btn btn-primary">
                                          <i class="fp-add"></i> Add Line Item
                                      </button>
                                  </div>
                              </div>
                              <hr class="light-hr"/>
                              <div class="purchase-order-create-main table-responsive-sm">
                                  <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                      <thead>
                                          <tr class="table-primary">
                                              <th scope="col" class="require" style="width:400px">Charge Type</th>
                                              <th scope="col">Quantity</th>
                                              <th scope="col">Price</th>
                                              <th scope="col">Amount</th>
                                              <th scope="col"> Action </th>
                                          </tr>
                                      </thead>
                                      <tbody>
                                          <tr v-for="(chrow, chindex) in chrows" :key="chindex">
                                              <td>
                                                  <v-select v-model="chrow.charge_id" name="charge_id" placeholder="Select Charge."
                                                              label="text"
                                                              :options="chargesArr" @input="onChargeSelect($event,chindex)">
                                                  </v-select>
                                                  <div class="field-error">{{chrow.charge_type_error_msg}}</div>
                                              </td>
                                              <td>
                                                  <input type="text" placeholder="Quantity" v-model="chrow.quantity" name="quantity" v-on:keyup="calculateChargeAmount($event,chindex)"
                                                    @keypress="isNumberOnly($event,chindex, 'chrow-qty')" @blur="leaveFocusUnitPrice($event,chindex,'chrow-qty')" id="quantity" class="form-control text-right">
                                                  <div class="field-error">{{chrow.quantity_error_msg}}</div>
                                              </td>
                                              <td>
                                                  <template v-if="purchase_order_type.value == 'item'">
                                                    <input type="text" placeholder="Price" v-model="chrow.unit_price" @input="validateChRawInput($event,chindex)"
                                                        v-on:keyup="calculateChargeAmount($event,chindex)" @blur="leaveFocusUnitPrice($event,chindex,'chrow-price')" @focus="enterUnitPrice($event,chindex,'chrow-price')"
                                                        @keypress="isNumberCheck($event,chindex, 'chrow-price')" name="row.unit_price" :id="'charge_price'+chindex" class="form-control text-right">
                                                  </template>
                                                  <template v-else>
                                                      <input type="text" placeholder="Price" v-model="chrow.unit_price" @input="validateChRawInput($event,chindex)"
                                                        v-on:keyup="calculateChargeAmount($event,chindex)"
                                                        @keypress="isNumberCheck($event,chindex, 'chrow-price')" name="row.unit_price" :id="'charge_price'+chindex" class="form-control text-right">
                                                  </template>
                                                  <div class="field-error">{{chrow.unit_price_error_msg}}</div>
                                              </td>
                                              <td>
                                                  <input type="text" disabled placeholder="Amount" v-model="chrow.amount" id="amount" name="amount" class="form-control text-right">
                                              </td>
                                              <td class="text-center valign-middle">
                                                  <!-- <template v-if="chrows.length != 1"> -->
                                                    <span class="close-row">
                                                          <a href="javascript:void(0);" v-on:click="removeChargeElement(chindex);"> ×</a>
                                                    </span>
                                                  <!-- </template>
                                                  <template v-else>
                                                      <span class="close-row"> _ </span>
                                                  </template> -->
                                              </td>
                                          </tr>
                                      </tbody>
                                  </table>
                              </div>
                              <div class="btn-groups">
                                  <button type="submit" v-on:click.prevent="addLine()" class="btn btn-primary">
                                      <i class="fp-add"></i> Add Charge
                                  </button>
                              </div>
                            </template>
                            <div class="order-summary mt-4" v-if="showTotalSummary">
                                <div class="row">
                                    <div class="col-md-6 offset-md-6">
                                        <div class="bg-white radius-5 p-3">
                                            <table aria-describedby="table" class="table table-sm table-bordered">
                                                <tr>
                                                    <td> Subtotal: </td>
                                                    <td class="text-right"> {{currencyFormat(sub_total)}} </td>
                                                </tr>
                                                <tr class="table-secondary">
                                                    <td> Total: </td>
                                                    <td class="order-total text-right"> {{currencyFormat(total)}} </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                    <strong id="errorMsg" class="field-error"></strong>
                                </div>
                            </div>
                            <div class="btn-groups">
                                <button type="submit" :disabled='isDisableStore' v-if="$route.params.id > 0" id="CreatePurchaseOrderBtn" class="btn btn-primary" v-on:click.prevent="CreatePurchaseOrder">
                                    <i class="fp-reload"> </i> Update
                                </button>
                                <button type="submit" v-else id="CreatePurchaseOrderBtn" class="btn btn-primary" v-on:click.prevent="CreatePurchaseOrder">
                                    <i class="fp-save"> </i> Save
                                </button>

                                <template v-if="purchase_order_type.value != 'equipment-osr'">

                                  <!-- <button type="submit" :disabled='isDisableStore' v-if="$route.params.id == undefined" id="createAndCreateInvoiceOrderBtn" class="btn btn-tertiary" v-on:click.prevent="CreatePurchaseOrder(flag='Invoice')">
                                      <i class="fp-save-continue"> </i> Save and Create Invoice
                                  </button> -->
                                  <button type="submit" :disabled='isDisableStore' v-if="$route.params.id == undefined && (purchase_order_type.value == 'item' || purchase_order_type.value == 'misc')" id="createAndCreateInvoiceOrderBtn" class="btn btn-tertiary" v-on:click.prevent="CreatePurchaseOrder(flag='Invoice')">
                                      <i class="fp-save-continue"> </i> Process and Record Receipt
                                  </button>
                                  <button type="submit" :disabled='isDisableStore' v-if="$route.params.id == undefined && purchase_order_type.value == 'item'" id="createAndProcessPOBtn" class="btn btn-tertiary" v-on:click.prevent="CreatePurchaseOrder(flag='Process')">
                                      <i class="hi-icon icon-flSave-Continue"> </i> Save and Process
                                  </button>
                                  <button type="submit" :disabled='isDisableStore' v-if="$route.params.id == undefined" id="createAndContinuePurchaseOrderBtn" class="btn btn-tertiary" v-on:click.prevent="CreatePurchaseOrder(flag='Save and Continue')">
                                      <i class="fp-save-continue"> </i> Save and Continue
                                  </button>
                                  <button type="submit" :disabled='isDisableStore' v-if="$route.params.id == undefined && reqId == 0" id="createAndContinuePurchaseOrderBtn" class="btn btn-tertiary" v-on:click.prevent="CreatePurchaseOrder(flag='Send with item')">
                                      <i class="fp-save-continue"> </i> Save and Send With Item
                                  </button>
                                  <button type="submit" :disabled='isDisableStore' v-if="$route.params.id == undefined && reqId == 0" id="createAndContinuePurchaseOrderBtn" class="btn btn-tertiary" v-on:click.prevent="CreatePurchaseOrder(flag='Send without item')">
                                      <i class="fp-save-continue"> </i> Save and Send Without Item
                                  </button>

                                </template>
                                <button type="submit" id="cancelPurchaseOrderBtn" class="btn btn-tertiary" v-on:click.prevent="goPreviousPath">
                                    <i class="fp-close"> </i> Cancel
                                </button>
                            </div>
                        </form>

                    </section>
                </div>
            </div>
        </template>
        <template v-else-if="cantAccessPage === false">
            <div class="container-fluid">
                <div class="bg-white text-center">
                    <h1>
                        Oops!</h1>
                    <h2>
                        403 </h2>
                    <div class="error-details">
                        Sorry!, You don't have permission to access this page.
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <loading-content></loading-content>
        </template>
        <app-footer></app-footer>
    </div>
</div>
</template>

<script>
import Vue from "vue";

import {commonMixins } from '../mixins/commonMixins';
import { contractMixins } from '../mixins/contractMixins';

import moment from 'moment';
// import flatPickr from 'vue-flatpickr-component';
// import 'flatpickr/dist/flatpickr.css';
import datePicker from 'vue-bootstrap-datetimepicker';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
Vue.use(datePicker);


export default {
    name: "VendorPurchaseOrderCreate",
    metaInfo() {
        return {
            title: (this.$route.params.id > 0)? "Update Vendor Purchase Order | " +process.env.COPYRIGHT_NAME : "Create Vendor Purchase Order | " +process.env.COPYRIGHT_NAME
        }
    },
    mixins: [commonMixins, contractMixins],
    data: () => ({
      year:'',
      vehicle_model_id: '',
      modelArr: [],
      vehicle_manufacturer_id: '',
      vehicleManufacturerArr: [],
      estimate_cost: '',
      estimate_cost_error_msg: '',
      vehicleTypeArr: [],
      vehicle_type: '',
      vehicle_type_error_msg: '',
      osr_asset_pool: '',
      osr_asset_pool_error_msg: '',
      unit: '',
      unit_error_msg: '',
      vendorUnit: '',
      vendorUnit_error_msg: '',
      vin: '',
      vin_error_msg: '',

      optionsDateTime:{
            format: 'MM/DD/YYYY hh:mm:ss a',
            useCurrent: true,
            showClose:true
        },
        sectionArr: ['DISTANCE', 'REEFER HOURS', 'ENGINE HOURS'],
        isDisableStore: false,
        isEdit: false,
        permissions: [],
        cantAccessPage: "",
        po_number: "",
        po_number_error_msg: "",
        vendor_id: null,
        vendorArr: [],
        ordering_location_id: null,
        assigned_location_id: null,
        ship_to_location_id: null,
        delivery_date: "",
        locationArr: [],
        open_status: "open",
        closed_status: "closed",
        reserved__status: "reserved",
        openCheckBox: "1",
        closedCheckBox: "1",
        reservedCheckBox: "1",
        loading: false,
        // po_number_error_msg: "",
        assigned_location_error_msg: "",
        ordering_location_error_msg: "",
        ship_to_location_error_msg: "",
        delivery_date_error_msg: "",
        status_error_msg: "",
        showCharges: false,
        type: "",
        statusArr: [{
                value: "open",
                text: "Open"
            },
            {
                value: "closed",
                text: "Closed"
            },
            // {
            //     value: "reserved",
            //     text: "Reserved"
            // },
        ],
        status: {
            value: "open",
            text: "Open"
        },
        type_error_msg: "",
        amount_error_msg: "",
        tax_percentage_error_msg: "",
        total_charge_error_msg: "",
        optionsDate: {
            format: 'MM/DD/YYYY',
            useCurrent: false,
        },
        rows: [],
        eqp_po_rows: [],
        model_code: "",
        modelcodeArr: [],
        asset_pool_id: "",
        assetpoolArr: [],
        sub_total: 0,
        total: 0,
        total_tax: 0,
        notes: "",
        attention: "",
        customerArr: [],
        userArr: [],
        customer_id: null,
        customer_error_msg: "",
        //sales_person_id: null,
        sales_person_error_msg: "",
        purchase_order_type: {
            text: 'Item',
            value: 'item'
        },
        purchase_order_type_error_msg: "",
        order_date: "",
        due_date: "",
        order_date_error_msg: "",
        due_date_error_msg: "",
        showItemFields: true,
        itemArr: [],
        itemDisplay: true,
        vendor_error_msg: "",
        disablePurchaseOrderTypeField:false,
        fromWoView:false,
        amount:'',
        wo_amount_error_msg:'',
        notes_error_msg:'',
        work_oid:0,
        reqId:0,
        showTotalSummary:false,
        chrows:[],
        chargesArr:[],
        purchaseOrderTypesArr:[
            {text:'Item' , value:'item'},
            // {text:'Equipment' , value:'equipment'},
            {text:'Equipment OSR' , value:'equipment-osr'},
            // {text:'Sublet PO' , value:'sublet_po'},
            {text:'Miscellaneous' , value:'misc'},
        ],
        poVendorInvoice:"",
        bill_number:'',
        accountsArr:[],
        vomArr:[],
        vehicleArr:[],
        assetPoolArr:[],
        defaultChargesArr:[],
        fromCopyPage: 'NO',
        conTypeDisable:true
    }),

    watch: {

        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_purchase_order') {
                        self.cantAccessPage = true;
                    }
                }
            }

        },
        sub_total: function () {

            var self = this;
            self.total = self.removeFormat(self.total_tax) + self.removeFormat(self.sub_total);
        },
        total_tax: function () {
            var self = this;
            self.total = self.removeFormat(self.total_tax) + self.removeFormat(self.sub_total);
        },

        showCharges() {
            var self = this;
            if (self.showCharges) {
                //self.getPurchaseOrderChargesData();
            }
        },
        purchase_order_type: function (type) {
            var self = this;
            var path = window.location.pathname;
            var segments = path.split("/");
            console.log(type);
            if (!segments[3] && self.$route.params.copy_id == undefined) {
                self.rows = [];
                // self.chargesArr = [];
                self.showTotalSummary = false;

                if (type.value == 'item' || type.value == 'misc') {
                    this.showItemFields = true;
                } else {
                    this.showItemFields = false;
                    self.rows = [];
                }
                //if po type is equipment then only mso charges will be loaded
                if (type.value == 'equipment') {
                    self.chargesArr = [];
                    for(var i = 0;i < self.defaultChargesArr.length;i++){
                        if (self.defaultChargesArr[i].identifier == "DMVELECFIL" ||
                            self.defaultChargesArr[i].identifier == "MSOTITLEFEE" ||
                            self.defaultChargesArr[i].identifier == "licensing_fee"){
                            self.chargesArr.push(self.defaultChargesArr[i]);
                        }
                    }
                }else{
                    self.chargesArr = [];
                    for(var i = 0;i < self.defaultChargesArr.length;i++){
                        self.chargesArr.push(self.defaultChargesArr[i]);
                    }
                }

                if (type.value == 'sublet_po') {
                    self.chrows = [];
                    var sublet_labor = null;
                    var sublet_part = null;
                    var obj = self.chargesArr;
                    $.each(obj, function (key, chargevalue) {
                        if (chargevalue.identifier == 'sublet_labor') {
                            sublet_labor = {
                                value: chargevalue.value,
                                text: chargevalue.text,
                            };
                        }
                        if (chargevalue.identifier == 'sublet_part') {
                            sublet_part = {
                                value: chargevalue.value,
                                text: chargevalue.text,
                            };
                        }
                    });

                    console.log(sublet_labor);
                    console.log(sublet_part);

                    //Sublet Labor
                    self.chrows.push({
                        purchase_order_item_id:0,
                        quantity: 1,
                        quantity_error_msg: "",
                        unit_price: 0,
                        unit_price_error_msg: "",
                        amount: 0,
                        amountEdit: true,
                        charge_id:(sublet_labor != undefined && sublet_labor != null)?sublet_labor:{text:"Sublet Labor",value:"sublet_labor"},
                        description:"",
                        desc_error_msg:"",
                        disableChargeSelect:true,
                        amount_error_msg:"",
                        charge_type_error_msg:"",
                        vehicle_id:"",
                        wo_item_id:""
                    });
                    //Sublet Part
                    self.chrows.push({
                        purchase_order_item_id:0,
                        quantity: 1,
                        quantity_error_msg: "",
                        unit_price: 0,
                        unit_price_error_msg: "",
                        amount: 0,
                        amountEdit: true,
                        charge_id:(sublet_part != undefined && sublet_part != null)?sublet_part:{text:"Sublet Part",value:"sublet_part"},
                        description:"",
                        desc_error_msg:"",
                        disableChargeSelect:true,
                        amount_error_msg:"",
                        charge_type_error_msg:"",
                        vehicle_id:"",
                        wo_item_id:""
                    });
                    self.chrows.push({
                        purchase_order_item_id: 0,
                        charge_id: null,
                        charge_type_error_msg: "",
                        quantity: 0,
                        quantity_error_msg: "",
                        unit_price: 0,
                        unit_price_error_msg: "",
                        amount: 0,
                        amountEdit: true,
                        description:"",
                        desc_error_msg:"",
                        disableChargeSelect:false,
                        amount_error_msg:"",
                        vehicle_id:"",
                        wo_item_id:""
                    });
                } else if(type.value == 'equipment-osr') {
                    self.eqp_po_rows.push({
                      section_type: '',
                      section_type_error_msg: '',
                      reading_date: '',
                      reading_date_error_msg: '',
                      reading: '',
                      reading_error_msg: '',
                    });
                } else{
                    self.rows.push({
                        purchase_order_item_id: 0,
                        model_code: null,
                        model_error_msg: "",
                        year: "",
                        year_error_msg: "",
                        quantity: 0,
                        quantityEdit: true,
                        quantity_error_msg: "",
                        asset_pool_id: null,
                        asset_pool_error_msg: "",
                        unit_price: 0,
                        unit_priceEdit: true,
                        unit_price_error_msg: "",
                        tax_percentage: 0,
                        tax_percentage_error_msg: "",
                        tax_amount: 0,
                        tax_amount_error_msg: "",
                        amount: 0,
                        description: "",
                        desc_error_msg: "",
                        part: null,
                        part_error_msg: "",
                        vendor_estimate_id: '',
                        gl_account_id:null,
                        account_error_msg:'',
                        measurement_unit_id:null,
                        vehicle_id:null
                    });

                    self.chrows = [];
                    self.chrows.push({
                        purchase_order_item_id: 0,
                        charge_id: null,
                        charge_type_error_msg: "",
                        quantity: 0,
                        quantity_error_msg: "",
                        unit_price: 0,
                        unit_price_error_msg: "",
                        amount: 0,
                        amountEdit: true,
                        description:"",
                        desc_error_msg:"",
                        disableChargeSelect:false,
                        amount_error_msg:"",
                        vehicle_id:"",
                        wo_item_id:""
                    });
                }

            }
        },

        vehicle_manufacturer_id: function(vehicle_manufacturer_id) {

            var self = this;

            if(self.vehicle_manufacturer_id == null || self.vehicle_manufacturer_id == ""){
                self.vehicle_model_id = null;
                self.modelArr = [];
                return;
            }

            $.ajax({
                url: process.env.ROOT_API + "/assetmodel/search",
                type: "GET",
                headers: this.ajxHeaders,
                crossDomain: true,
                dataType:"json",
                data:{
                    id:vehicle_manufacturer_id.value,
                },
                success: function (data) {
                    //if data is edit than dont make model id blank
                    if ( !self.isEdit ) {
                        // self.vehicle_model_id = "";
                    }
                    self.isEdit = false;
                    if (data.status == "success") {

                        if(self.is_group_call==true){
                            self.is_group_call=false;
                        }else{
                            if ( self.approvedPo == 0){

                                self.vehicle_model_id = null;

                            }
                            self.modelArr = data.content.vehiclemodels;

                        }
                    }

                },
                error: function (jqXHR, exception) {
                    self.Registerbtn = "Register";
                    if (jqXHR.status == 0) {
                        self.error = "Remote server cannot be reached";
                    } else {
                    //redirect to login page if user not authenticated
                    if (jqXHR.status == 401) {
                        //clear previous data
                        localStorage.removeItem("user_obj");
                        localStorage.removeItem("tkn");

                        self.$router.push("/");
                    }
                        self.error = jqXHR.responseJSON.message;
                    }
                }
            });
        },

        vehicle_id: function(val) {

        }

    },
    created: function () {

    },
    mounted: function () {
        var self = this;
        // self.statusValue = 1;
        var path = window.location.pathname;
        var segments = path.split("/");

        var userObj = JSON.parse(localStorage.getItem("user_obj"));
        if (userObj != null) {

            //set LoggedIn user's location as default location....
            if (userObj["location_id"] != null && userObj["location_id"] != '') {
                self.ordering_location_id = {
                    value: userObj["location_id"],
                    text: userObj["locationCode"] + " | "+ self.titleCase(userObj["locationName"])
                };
                self.assigned_location_id = {
                    value: userObj["location_id"],
                    text: userObj["locationCode"] + " | "+ self.titleCase(userObj["locationName"])
                };
                self.ship_to_location_id = {
                    value: userObj["location_id"],
                    text: userObj["locationCode"] +" | "+ self.titleCase(userObj["locationName"])
                };
            }

        }

        self.getPermissions();
        self.loadFieldData(['location','mso_charges','vendor_po_charges','equipment-osr-asset-pool','vehicle_manufacturer','vehicle_pool',"vehicleType","measurementUnit"], 'vendor_po_create');


        var path = window.location.pathname;
        var segments = path.split("/");

        if (segments[3]) {

            self.loadPurchaseOrder();
            setTimeout(function(){
                self.loadPurchaseOrderItem();
            },100);
            // self.getPurchaseOrderChargesData();
        }
        // else {
        //     //get po_number.
        //     self.getPoNumber(userObj["location_id"]);
        // }

        self.rows.push({
            purchase_order_item_id: 0,
            model_code: null,
            model_error_msg: "",
            year: "",
            year_error_msg: "",
            quantity: 0,
            quantityEdit: true,
            quantity_error_msg: "",
            asset_pool_id: null,
            asset_pool_error_msg: "",
            unit_price: 0,
            unit_priceEdit: true,
            unit_price_error_msg: "",
            tax_percentage: 0,
            tax_percentage_error_msg: "",
            tax_amount: 0,
            tax_amount_error_msg: "",
            amount: 0,
            description: "",
            desc_error_msg: "",
            part: null,
            part_error_msg: "",
            vendor_estimate_id: '',
            gl_account_id:null,
            account_error_msg:'',
            measurement_unit_id:null,
            vehicle_id:null
        });

        self.chrows.push({
            purchase_order_item_id: 0,
            charge_id: null,
            charge_type_error_msg: "",
            quantity: 0,
            quantity_error_msg: "",
            unit_price: 0,
            unit_price_error_msg: "",
            amount: 0,
            amountEdit: true,
            description:"",
            desc_error_msg:"",
            disableChargeSelect:false,
            amount_error_msg:"",
            vehicle_id:"",
            wo_item_id:""
        });

        var estimateWoId = self.$route.params.estimateWoId;
        if (estimateWoId && self.$route.params.redirectFrom == 'VendorEstimateList') {

            self.vendor_estimate_id = estimateWoId;
            // this.itemDisplay = false;
            self.purchase_order_type = {text:'Sublet PO',value:'sublet_po'};
            self.loadEstimateData(estimateWoId);
            // $("#purchase_order_type").addClass("disable-field");
            self.disablePurchaseOrderTypeField = true;
        }

        if (self.$route.params.requisitionId != undefined) {
            self.reqId = self.$route.params.requisitionId;
            if (self.reqId && self.$route.params.redirectFrom == 'AssetRequisition') {

                self.loadAssetRequisition();
                self.disablePurchaseOrderTypeField = true;
            }
        }

        var webloc = window.location.href;

         var decodeStr = "";
        if ( this.$route.query.data != '' && this.$route.query.data != undefined ) {
            decodeStr = atob(this.$route.query.data)
        }

        var url = new URL(webloc+"?"+decodeStr);
        var woId = url.searchParams.get("woId");
        self.work_oid = url.searchParams.get("woId");
        self.woiId = url.searchParams.get("woItemId");
        var from = url.searchParams.get("redirectFrom");

        setTimeout(function () {
            if(from == 'WorkOrderView'){
                self.purchase_order_type = {text:'Sublet PO',value:'sublet_po'};
                self.showItemFields = true;
                self.loadWorkOrder(woId)
                self.getWorkOrderDataForPO(woId,self.woiId);
                self.fromWoView = true;
                // self.getWorkOrderDataForEstimate(woId,woiId);
            }

            if(from == 'osr') {
              self.purchase_order_type = {text:'Equipment OSR' , value:'equipment-osr'};
              self.disablePurchaseOrderTypeField = true;
            }

        },1000);

        if (!from || from != 'WorkOrderView'){

            setTimeout(function () {
                if (!segments[3]) {
                    self.order_date = moment().format("MM/DD/YYYY");
                }
            }, 1500);
        }

        if ( self.$route.query.from == 'asset'){

            self.purchase_order_type = {text:'Equipment',value:'equipment'};
            self.disablePurchaseOrderTypeField = true;

        }
        if(self.$route.params.copy_id != undefined){
          console.log(self.$route.params.copy_id);
          self.fromCopyPage = 'YES';
          self.loadPurchaseOrder();
            setTimeout(function(){
                self.loadPurchaseOrderItem();
            },100);
        }

        setTimeout(function () {
            if(self.purchase_order_type.value && self.purchase_order_type.value == 'equipment-osr') {
                self.conTypeDisable = false;
            }
        },1000);

    },
    methods: {

        getPoNumber(locId) {
            let self = this;
            $.ajax({
                url: process.env.ROOT_API + "/vendor-purchase-order/get-po-number",
                type: "POST",
                data: {
                    'locId': locId
                },
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {
                        self.po_number = data.content.po_number;
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'vendor-po-create-get-po-no')
                }
            });
        },
        onSearchAccount(search, loading) {
            var self = this;
            if (search.length > 2) {

                loading(true);
                self.searchField(loading, search, 'accounts', '');
            }
        },

        loadWorkOrder(wo_id) {
            var path = window.location.pathname;
            var segments = path.split("/");
            var self = this;
            self.loading = true;


            $.ajax({
                url: process.env.ROOT_API + "/workorder/" + wo_id,
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    // console.log(data);
                    if (data.status == "success") {

                        self.order_date = data.content.open_date;

                        self.notes = data.content.description;

                        if (data.content.location_id) {
                            self.ordering_loc_id = {
                                value: data.content.location_id,
                                text: self.titleCase(data.content.lName) + ' | ' + data.content.lCode
                            };
                            self.assigned_loc_id = {
                                value: data.content.location_id,
                                text: self.titleCase(data.content.lName) + ' | ' + data.content.lCode
                            };
                            self.ship_loc_id = {
                                value: data.content.location_id,
                                text: self.titleCase(data.content.lName) + ' | ' + data.content.lCode
                            };
                        }

                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'vendor-po-create-load-wo')

                }
            });
        },
        loadEstimateData(estId) {
            var self = this;

            $.ajax({
                url: process.env.ROOT_API + "/vendor-estimate/" + estId,
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    // console.log(data);
                    if (data.status == "success") {

                        var date = '';
                        if (data.content.open_date && data.content.open_date != '') {

                            date = data.content.open_date.split(' ');
                            self.order_date = date[0];
                        }

                        self.due_date = data.content.expiry_date;

                        self.vendor_id = {
                            value: data.content.vendor_id,
                            text: self.titleCase(data.content.venCode) + " | " + data.content.venName
                        };

                        // self.status = {value: data.content.status, text: self.titleCase(data.content.status)};

                        self.notes = data.content.description;

                        if (data.content.location_id) {
                            self.assigned_location_id = {
                                value: data.content.location_id,
                                text: self.titleCase(data.content.lName) + ' | ' + data.content.lCode
                            };
                            self.ordering_location_id = {
                                value: data.content.location_id,
                                text: self.titleCase(data.content.lName) + ' | ' + data.content.lCode
                            };
                            self.ship_to_location_id = {
                                value: data.content.location_id,
                                text: self.titleCase(data.content.lName) + ' | ' + data.content.lCode
                            };
                        }
                        self.loadEstimateItem(estId);
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'vendor-po-create-load-estimate')
                }
            });
        },
        taxPercentage($event, index) {
            var self = this;

            if (self.rows[index].quantity && self.rows[index].unit_price) {
                self.calculateTaxSubTotal();
            } else {
                self.rows[index].tax_percentage = "";
                if (self.rows[index].quantity == null || !self.rows[index].quantity) {
                    self.rows[index].quantity_error_msg = "Quantity is Required.";
                }
                if (self.rows[index].unit_price == null || !self.rows[index].unit_price) {
                    self.rows[index].unit_price_error_msg = "Unit Price is Required.";
                }
            }

        },
        onSearchCustomer(search, loading) {
            var self = this;
            if (search.length > 2) {
                loading(true);
                self.searchField(loading, search, 'customer', '');
            }
        },
        onSearchUser(search, loading) {
            var self = this;
            if (search.length > 0) {

                loading(true);
                self.searchField(loading, search, 'user', '');
            }
        },
        onSearchModel(search, loading) {
            var self = this;
            if (search.length > 2) {

                loading(true);
                self.searchField(loading, search, 'vehicle_model', '');
            }
        },
        // onSearchAssetPool(search, loading) {
        //     var self = this;
        //     if (search.length > 1) {
        //         loading(true);
        //         self.searchField(loading, search, 'vehicle_pool', '');
        //     }
        // },
        onSearchComponent(search, loading) {
            var self = this;
            if (search.length > 1) {
                loading(true);
                if (self.purchase_order_type != null && self.purchase_order_type.value && self.purchase_order_type.value == 'sublet_po'){

                        // self.searchField(loading, search, 'component','');
                        self.searchField(loading, search, 'default component','');
                }else{
                    // if (self.assigned_location_id != null && self.assigned_location_id.value){

                    //     // self.searchField(loading, search, 'exist component', self.assigned_location_id.value);
                    //     self.searchField(loading, search, 'default exist component', self.assigned_location_id.value);

                    // }else{
                    //     self.assigned_location_error_msg = 'Please select location';
                    //     // self.searchField(loading, search, 'available component', '');
                    // }
                }
                self.searchField(loading, search, 'item', '');
            }
        },
        onSearchVendor(search, loading) {
            var self = this;
            if (search.length > 2) {

                loading(true);
                self.searchField(loading, search, 'vendor', '');
            }
        },
        addPOReadingRow: function() {
          var self = this;
          var index = self.eqp_po_rows.length - 1;

          self.eqp_po_rows[index].section_type_error_msg = "";
          self.eqp_po_rows[index].reading_date_error_msg = "";
          self.eqp_po_rows[index].reading_error_msg = "";

          var error = false;
          if(self.eqp_po_rows[index].section_type == '') {
            self.eqp_po_rows[index].section_type_error_msg = "Section Type is required";
            error = true;
          }
          if(self.eqp_po_rows[index].reading_date == '') {
            self.eqp_po_rows[index].reading_date_error_msg = "Reading Date is required";
            error = true;
          }
          if(self.eqp_po_rows[index].reading == '') {
            self.eqp_po_rows[index].reading_error_msg = "Reading is required";
            error = true;
          }

          if(!error) {

            if(self.eqp_po_rows.length < 3) {
              var idx = self.sectionArr.findIndex(obj => obj == self.eqp_po_rows[index].section_type);
              if (idx != -1) {
                self.sectionArr.splice(idx, 1);
              }

              self.eqp_po_rows.push({
                  section_type: '',
                  section_type_error_msg: '',
                  reading_date: '',
                  reading_date_error_msg: '',
                  reading: '',
                  reading_error_msg: '',
              });
            }

          }
        },
        addRow: function () {

            var self = this;
            var index = self.rows.length - 1;

            self.rows[index].quantity_error_msg = "";
            self.rows[index].unit_price_error_msg = "";
            self.rows[index].model_error_msg = "";
            self.rows[index].asset_pool_error_msg = "";
            self.rows[index].part_error_msg = "";
            self.rows[index].desc_error_msg = "";

            if (self.showItemFields) {

                var checkQty = 0;
                if ( self.rows[index].quantity != '' && self.rows[index].quantity != null ) {
                    checkQty = self.removeFormat(self.rows[index].quantity);
                }

                if( String(self.rows[index].quantity).includes(':') ) {
                    var quant = self.rows[index].quantity.split(':');
                    self.rows[index].quantity = quant[0];
                }

                var checkUnitPrice = self.rows[index].unit_price;
                if (self.purchase_order_type.value == "item" || self.purchase_order_type.value == "misc") {
                    if (String(checkUnitPrice).includes(',') && checkUnitPrice != "") {
                        checkUnitPrice = self.removeFormat(self.rows[index].unit_price);
                    }
                }

                if (self.purchase_order_type.value == "item") {

                    if (( checkQty > 0 || checkQty < 0) && (Number(checkQty) > 0 || Number(checkQty) < 0) && checkQty != null) {

                        self.rows.push({
                            purchase_order_item_id: 0,
                            model_code: null,
                            model_error_msg: "",
                            year: "",
                            year_error_msg: "",
                            quantity: 0.000,
                            quantityEdit: true,
                            quantity_error_msg: "",
                            asset_pool_id: null,
                            asset_pool_error_msg: "",
                            unit_price: 0.000,
                            unit_priceEdit: true,
                            unit_price_error_msg: "",
                            tax_percentage: 0,
                            tax_percentage_error_msg: "",
                            tax_amount: 0,
                            tax_amount_error_msg: "",
                            amount: 0.000,
                            description: "",
                            desc_error_msg: "",
                            part: null,
                            part_error_msg: "",
                            vendor_estimate_id: '',
                            gl_account_id:null,
                            account_error_msg:'',
                            measurement_unit_id:null,
                            vehicle_id:null
                        });

                    }else{

                        if (self.rows[index].quantity == null || !self.rows[index].quantity || self.rows[index].quantity == 0.000 ) {
                            self.rows[index].quantity_error_msg = "Quantity is Required.";
                        }
                        if (self.rows[index].unit_price == null || !self.rows[index].unit_price || self.rows[index].unit_price == 0.000 ) {
                            self.rows[index].unit_price_error_msg = "Unit Price is Required.";
                        }
                    }

                } else {

                    if ((self.rows[index].description != null && self.rows[index].description != "") &&
                        (self.rows[index].quantity > 0 || self.rows[index].quantity < 0) && (Number(checkUnitPrice) > 0 || Number(checkUnitPrice) < 0) && self.rows[index].quantity != null) {

                        self.rows.push({
                            purchase_order_item_id: 0,
                            model_code: null,
                            model_error_msg: "",
                            year: "",
                            year_error_msg: "",
                            quantity: 0,
                            quantityEdit: true,
                            quantity_error_msg: "",
                            asset_pool_id: null,
                            asset_pool_error_msg: "",
                            unit_price: 0,
                            unit_priceEdit: true,
                            unit_price_error_msg: "",
                            tax_percentage: 0,
                            tax_percentage_error_msg: "",
                            tax_amount: 0,
                            tax_amount_error_msg: "",
                            amount: 0,
                            description: "",
                            desc_error_msg: "",
                            part: null,
                            part_error_msg: "",
                            vendor_estimate_id: '',
                            gl_account_id:null,
                            account_error_msg:'',
                            measurement_unit_id:null,
                            vehicle_id:null
                        });

                    } else {

                        if (self.rows[index].quantity == null || !self.rows[index].quantity || self.rows[index].quantity == 0) {
                            self.rows[index].quantity_error_msg = "Quantity is Required.";
                        }
                        if (self.rows[index].unit_price == null || !self.rows[index].unit_price || self.rows[index].unit_price == 0) {
                            self.rows[index].unit_price_error_msg = "Unit Price is Required.";
                        }
                        /*if ((self.rows[index].part == null || !self.rows[index].part.value) && (self.rows[index].description == null || self.rows[index].description == "")) {
                            if (self.rows[index].part == null || !self.rows[index].part.value) {
                                self.rows[index].part_error_msg = "Part is Required.";
                            }
                            if (self.rows[index].description == null || self.rows[index].description == "") {
                                self.rows[index].desc_error_msg = "Description is Required.";
                            }

                        }*/
                        if (self.purchase_order_type.value == 'item') {
                            /*if (self.rows[index].part == null || !self.rows[index].part.value) {
                                self.rows[index].part_error_msg = "Part is Required.";
                            }*/
                        }else if (self.purchase_order_type.value == 'sublet_po'){
                            if ((self.rows[index].part == null || !self.rows[index].part.value) && (self.rows[index].description == null || self.rows[index].description == "")) {
                                if (self.rows[index].part == null || !self.rows[index].part.value) {
                                    self.rows[index].part_error_msg = "Part is Required.";
                                }
                                if (self.rows[index].description == null || self.rows[index].description == "") {
                                    self.rows[index].desc_error_msg = "Detail is Required.";
                                }

                            }
                        }else if(self.purchase_order_type.value == 'misc'){
                            if (self.rows[index].description == null || self.rows[index].description == "") {
                                self.rows[index].desc_error_msg = "Detail is Required.";
                            }
                        }

                    }
                }

            } else {

                if (self.rows[index].model_code != null && self.rows[index].model_code.value && self.rows[index].quantity &&
                    self.rows[index].unit_price && self.rows[index].asset_pool_id != null && self.rows[index].asset_pool_id
                    .value) {

                    self.rows.push({
                        purchase_order_item_id: 0,
                        model_code: null,
                        model_error_msg: "",
                        year: "",
                        year_error_msg: "",
                        quantity: 0,
                        quantityEdit: true,
                        quantity_error_msg: "",
                        asset_pool_id: null,
                        asset_pool_error_msg: "",
                        unit_price: 0,
                        unit_priceEdit: true,
                        unit_price_error_msg: "",
                        tax_percentage: 0,
                        tax_percentage_error_msg: "",
                        tax_amount: 0,
                        tax_amount_error_msg: "",
                        amount: 0,
                        description: "",
                        desc_error_msg: "",
                        asset_requisition_id: self.reqId,
                        part: null,
                        part_error_msg: "",
                        vendor_estimate_id: '',
                        gl_account_id:null,
                        account_error_msg:'',
                        measurement_unit_id:null,
                        vehicle_id:null
                    });

                } else {
                    if (self.rows[index].quantity == null || !self.rows[index].quantity) {
                        self.rows[index].quantity_error_msg = "Quantity is Required.";
                    }
                    if (self.rows[index].unit_price == null || !self.rows[index].unit_price) {
                        self.rows[index].unit_price_error_msg = "Unit Price is Required.";
                    }
                    if (self.rows[index].model_code == null || !self.rows[index].model_code.value) {
                        self.rows[index].model_error_msg = "Model Code is Required.";
                    }
                    if (self.rows[index].asset_pool_id == null || !self.rows[index].asset_pool_id.value) {
                        self.rows[index].asset_pool_error_msg = "Asset Pool is Required.";
                    }
                }
            }
            if ( self.rows.length > 1) {
                self.showTotalSummary = true;
            }else{
                self.showTotalSummary = false;
            }
        },
        removeEqpPOReadingElement: function (index) {
            var self = this;
            if (self.eqp_po_rows.length > 1) {
              var idx = self.sectionArr.findIndex(obj => obj == self.eqp_po_rows[index].section_type);
              if (idx == -1) {
                self.sectionArr.push(self.eqp_po_rows[index].section_type);
              }
              self.eqp_po_rows.splice(index, 1);
            }
        },
        removeElement: function (index) {
            var self = this;
            if (self.rows.length > 1) {
                if (self.rows[index].purchase_order_item_id == 0) {
                    self.rows.splice(index, 1);
                    self.calculateTaxSubTotal();

                } else {
                    if (confirm('Are you sure that you want to delete this Purchase Order Item? ')) {
                        $.ajax({
                            url: process.env.ROOT_API + "/purchaseorderitem/delete",
                            type: "POST",
                            data: {
                                'id': self.rows[index].purchase_order_item_id
                            },
                            headers: this.ajxHeaders,
                            dataType: "json",
                            success: function (data) {
                                if (data.status == "success") {
                                    self.rows.splice(index, 1);
                                    self.calculateTaxSubTotal();
                                }

                            },
                            error: function (jqXHR, exception) {
                                self.generateStatusCodeMessage(jqXHR,true,'vendor-po-create-delete-item')
                            },
                        });
                    }
                }
            }
            if (self.rows.length > 1) {
                self.showTotalSummary = true;
            }else{
                self.showTotalSummary = false;
            }
        },
        addLine: function () {

            var self = this;
            var index = self.chrows.length - 1;

            self.chrows[index].quantity_error_msg = "";
            self.chrows[index].unit_price_error_msg = "";
            self.chrows[index].charge_type_error_msg = "";
            self.chrows[index].amount_error_msg = "";

            //Sublet PO
            if (self.purchase_order_type.value == 'sublet_po') {

                if (self.chrows[index].charge_id != null && self.chrows[index].charge_id.value && self.chrows[index].amount &&
                    self.chrows[index].amount) {

                    self.chrows.push({
                        purchase_order_item_id: 0,
                        charge_id: null,
                        charge_type_error_msg: "",
                        quantity: 0,
                        quantity_error_msg: "",
                        unit_price: 0,
                        unit_price_error_msg: "",
                        amount: 0,
                        amountEdit: true,
                        description:"",
                        desc_error_msg:"",
                        disableChargeSelect:false,
                        amount_error_msg:"",
                        vehicle_id:"",
                        wo_item_id:""
                    });

                }else{
                    if (self.chrows[index].charge_id == null || !self.chrows[index].charge_id.value) {
                        self.chrows[index].charge_type_error_msg = "Charge Type is Required.";
                    }
                    if (self.chrows[index].amount == null || !self.chrows[index].amount) {
                        self.chrows[index].amount_error_msg = "Amount is Required.";
                    }
                }

            }else{
                if (self.chrows[index].charge_id != null && self.chrows[index].charge_id.value && self.chrows[index].quantity &&
                    self.chrows[index].unit_price && (self.chrows[index].unit_price > 0)) {

                    self.chrows.push({
                        purchase_order_item_id: 0,
                        charge_id: null,
                        charge_type_error_msg: "",
                        quantity: 0,
                        quantity_error_msg: "",
                        unit_price: 0,
                        unit_price_error_msg: "",
                        amount: 0,
                        amountEdit: true,
                        description:"",
                        desc_error_msg:"",

                        disableChargeSelect:false,
                        amount_error_msg:"",
                        vehicle_id:"",
                        wo_item_id:""
                    });

                } else {
                    if (self.chrows[index].quantity == null || !self.chrows[index].quantity) {
                        self.chrows[index].quantity_error_msg = "Quantity is Required.";
                    }
                    if (self.chrows[index].unit_price == null || !self.chrows[index].unit_price || self.chrows[index].unit_price == 0) {
                        self.chrows[index].unit_price_error_msg = "Unit Price is Required.";
                    }
                    if (self.chrows[index].charge_id == null || !self.chrows[index].charge_id.value) {
                        self.chrows[index].charge_type_error_msg = "Charge Type is Required.";
                    }
                }
            }

            if ( self.chrows.length > 1) {
                self.showTotalSummary = true;
            }else{
                self.showTotalSummary = false;
            }
        },
        removeChargeElement: function (index) {
            var self = this;
            // if (self.chrows.length > 1) {
                if (self.chrows[index].purchase_order_item_id == 0) {
                    self.chrows.splice(index, 1);
                    if (!self.chrows.length) {
                        self.chrows = [];
                        self.chrows.push({
                            purchase_order_item_id: 0,
                            charge_id: null,
                            charge_type_error_msg: "",
                            quantity: 0,
                            quantity_error_msg: "",
                            unit_price: 0,
                            unit_price_error_msg: "",
                            amount: 0,
                            amountEdit: true,
                            description:"",
                            desc_error_msg:"",
                            disableChargeSelect:false,
                            amount_error_msg:"",
                            vehicle_id:"",
                            wo_item_id:""
                        });
                    }
                    self.calculateChargeAmount('',0);

                } else {
                    if (confirm('Are you sure that you want to delete this Charges Item? ')) {
                        $.ajax({
                            url: process.env.ROOT_API + "/purchaseorderitem/delete",
                            type: "POST",
                            data: {
                                'id': self.chrows[index].purchase_order_item_id
                            },
                            headers: this.ajxHeaders,
                            dataType: "json",
                            success: function (data) {
                                if (data.status == "success") {
                                    // self.chrows.splice(index, 1);
                                    self.loadPurchaseOrderItem();
                                    self.calculateChargeAmount('',0);
                                }

                            },
                            error: function (jqXHR, exception) {
                                self.generateStatusCodeMessage(jqXHR,true,'vendor-po-create-delete-item')
                            },
                        });
                    }
                }
            // }
            if (self.chrows.length > 0) {
                self.showTotalSummary = true;
            }else{
                self.showTotalSummary = false;
            }
        },
        PurchaseOrderList() {
            var self = this;

            if (self.$route.params.from != undefined && self.$route.params.from == 'woView') {
                self.$router.push({name: 'WorkOrderView',params:{id:self.$route.params.woId}});
            }else{
                var previousPath = JSON.parse(localStorage.getItem('previousPath'))
                var previousListPath = JSON.parse(localStorage.getItem('previousListPath'))

                if(previousListPath != "/order-history/list"){
                    if ( window.location.search == "?from=asset") {
                        url = "/asset-purchase-order/list";
                        self.$router.push(url);
                    }else{
                        this.$router.push({ path: previousListPath})
                    }
                }
                else {
                    var url = "/order-history/list?from=vendor";
                    if ( window.location.search == "?from=asset") {
                        url = "/asset-purchase-order/list";
                    }
                    if (self.fromWoView){
                        url = "/workorder/view/"+self.work_oid;
                    }
                    self.$router.push(url);
                }
            }
        },
        CreatePurchaseOrder(flag) {
            var self = this;
            var error = false;
            self.po_number = self.po_number.toString().trim();
            self.po_number_error_msg ="";
            self.assigned_location_error_msg = "";
            self.ordering_location_error_msg = "";
            self.ship_to_location_error_msg = "";
            self.delivery_date_error_msg = "";
            self.status_error_msg = "";
            self.purchase_order_type_error_msg = "";
            self.order_date_error_msg = "";
            self.due_date_error_msg = "";
            self.wo_amount_error_msg = '';
            self.vendor_error_msg = '';
            self.notes_error_msg = "";
            var purchaseOrderChargesArr = [];

            if (!self.purchase_order_type || self.purchase_order_type == null || self.purchase_order_type == "") {
                self.purchase_order_type_error_msg = "Purchase order type required.";
                error = true;
            }
            if (self.purchase_order_type != null && self.purchase_order_type.value && self.purchase_order_type.value == 'equipment-osr'){
                if ( self.po_number == null || self.po_number == "") {
                    self.po_number_error_msg = "Purchase order no. required.";
                    error = true;
                }
            }

            if (!self.order_date || self.order_date == null || self.order_date == "") {
                self.order_date_error_msg = "Order date required.";
                error = true;
            }
            // if (!self.due_date || self.due_date == null || self.due_date == "") {
            //     self.due_date_error_msg = "Due Date Required.";
            //     error = true;
            // }

            if (!self.vendor_id || self.vendor_id == null || self.vendor_id == "") {
                self.vendor_error_msg = "Vendor required.";
                error = true;
            }
            if (!self.assigned_location_id || self.assigned_location_id == null || self.assigned_location_id == "") {
                self.assigned_location_error_msg = "Assigned location required.";
                error = true;
            }

            if (!self.ordering_location_id || self.ordering_location_id == null || self.ordering_location_id == "") {
                self.ordering_location_error_msg = "Ordering location required.";
                error = true;
            }
            if (!self.ship_to_location_id || self.ship_to_location_id == null || self.ship_to_location_id == "") {
                self.ship_to_location_error_msg = "Ship to location required.";
                error = true;
            }
            // if (!self.delivery_date || self.delivery_date == null || self.delivery_date == "") {
            //     self.delivery_date_error_msg = "Delivery Date Required.";
            //     error = true;
            // }
            if (self.delivery_date != null && self.delivery_date != "") {
                if (new Date(self.delivery_date) < new Date(self.order_date)) {
                    self.delivery_date_error_msg = "Delivery date should be greater than Order Date.";
                    error = true;
                }
            }

            // if (!self.status || self.status == null || self.status == "") {
            //     self.status_error_msg = "Status Required.";
            //     error = true;
            // }

            /* if (self.customer_id == null) {
                 self.customer_id = "";
                 error = true;
             }
             if (self.sales_person_id == null) {

                 self.sales_person_id = "";
                 error = true;
             }*/
            var checkNumber = /^[0-9]+(\.[0-9]+)?$/;


            if (flag == 'Send without item') {

                if (self.purchase_order_type.value != "item") {
                    if ( !self.amount || self.amount == ''){
                        self.wo_amount_error_msg = 'Amount Required';
                        error = true;
                    }
                }
                /*if ( !self.notes || self.notes == ''){
                    self.notes_error_msg = 'Description Required';
                    error = true;
                }*/

            }

            if(self.purchase_order_type.value != 'equipment-osr' && self.purchase_order_type.value != 'sublet_po') {

                for (var i = 0; i < self.rows.length; i++) {
                        // console.log(self.rows[i]);
                        self.rows[i].model_error_msg = "";
                        self.rows[i].desc_error_msg = "";
                        self.rows[i].asset_pool_error_msg = "";
                        self.rows[i].unit_price_error_msg = "";
                        self.rows[i].quantity_error_msg = "";
                        self.rows[i].part_error_msg = "";
                        self.rows[i].account_error_msg = "";

                    if (flag != 'Send without item') {
                        if (self.purchase_order_type.value == "item") {
                            //if (flag == 'Process') {
                                if ((self.rows[i].part == null || !self.rows[i].part.value)) {
                                    self.rows[i].part_error_msg = "Part is Required.";
                                    error = true;
                                }
                                if ((self.rows[i].quantity == null || !self.rows[i].quantity || self.rows[i].quantity == 0)) {
                                    self.rows[i].quantity_error_msg = "Quantity is Required.";
                                    error = true;
                                }
                                if ((self.rows[i].unit_price == null || !self.rows[i].unit_price || self.rows[i].unit_price == 0)) {
                                    self.rows[i].unit_price_error_msg = "Unit Price is Required.";
                                    error = true;
                                }
                            //}
                            //if Process and Record Receipt clicked
                            if (flag == 'Invoice') {
                                if (self.rows[i].part == null || !self.rows[i].part.value) {
                                self.rows[i].part_error_msg = "Part is Required.";
                                error = true;
                                }
                            }

                        }else
                        if (self.purchase_order_type.value == "misc") {

                            if (self.rows[i].unit_price == null || self.rows[i].unit_price == 0 || !self.rows[i].unit_price) {
                                self.rows[i].unit_price_error_msg = "Unit Price is Required.";
                                error = true;
                            }

                            if (self.rows[i].quantity == null || !self.rows[i].quantity || self.rows[i].quantity == 0) {
                                self.rows[i].quantity_error_msg = "Quantity is Required.";
                                error = true;
                            }
                            if (self.rows[i].gl_account_id == null || !self.rows[i].gl_account_id.value) {
                                self.rows[i].account_error_msg = "GL Account is Required.";
                                error = true;
                            }
                            if (self.rows[i].description == null || self.rows[i].description == '') {
                                self.rows[i].desc_error_msg = "Description is Required.";
                                error = true;
                            }

                        }
                        /*else if (self.purchase_order_type.value == "sublet_po") {
                            if ((self.rows[i].part == null || !self.rows[i].part.value) && (self.rows[i].description == null || self.rows[i].description == "")) {
                                if (self.rows[i].part == null || !self.rows[i].part.value) {
                                    self.rows[i].part_error_msg = "Part is Required.";
                                }
                                if (self.rows[i].description == null || self.rows[i].description == "") {
                                    self.rows[i].desc_error_msg = "Detail is Required.";
                                }

                                error = true;
                            }
                        }*/
                        else {

                            if (self.rows[i].model_code == null || !self.rows[i].model_code.value) {
                                self.rows[i].model_error_msg = "Model Code is Required.";
                                error = true;
                            }

                            if (self.rows[i].asset_pool_id == null || !self.rows[i].asset_pool_id.value) {
                                self.rows[i].asset_pool_error_msg = "Asset Pool is Required.";
                                error = true;
                            }

                        }

                    }
                }
            }

            if(self.purchase_order_type.value == 'equipment-osr') {
                for (var i = 0; i < self.eqp_po_rows.length; i++) {

                    self.eqp_po_rows[i].section_type_error_msg = "";
                    self.eqp_po_rows[i].reading_date_error_msg = "";
                    self.eqp_po_rows[i].reading_error_msg = "";
                    if (self.eqp_po_rows[i].section_type == null || self.eqp_po_rows[i].section_type == '' || !self.eqp_po_rows[i].section_type) {
                        self.eqp_po_rows[i].section_type_error_msg = "Section Type is Required.";
                        error = true;
                    }
                    if (!self.eqp_po_rows[i].reading_date || self.eqp_po_rows[i].reading_date == null || self.eqp_po_rows[i].reading_date == "") {
                        self.eqp_po_rows[i].reading_date_error_msg = "Reading Date Required.";
                        error = true;
                    }
                    if (!self.eqp_po_rows[i].reading || self.eqp_po_rows[i].reading == null || self.eqp_po_rows[i].reading == "") {
                        self.eqp_po_rows[i].reading_error_msg = "Reading Required.";
                        error = true;
                    }
                }

                self.unit_error_msg = "";
                self.vin_error_msg = "";
                self.osr_asset_pool_error_msg = "";
                self.vehicle_type_error_msg = "";
                self.estimate_cost_error_msg = "";

                if (!self.unit || self.unit == null || self.unit == "") {
                    self.unit_error_msg = "Unit Number is Required.";
                    error = true;
                }
                if (!self.vin || self.vin == null || self.vin == "") {
                    self.vin_error_msg = "VIN Number is Required.";
                    error = true;
                }
                if (!self.osr_asset_pool || self.osr_asset_pool == null || self.osr_asset_pool == "") {
                    self.osr_asset_pool_error_msg = "Asset Pool is Required.";
                    error = true;
                }
                if (!self.vehicle_type || self.vehicle_type == null || self.vehicle_type == "") {
                    self.vehicle_type_error_msg = "Asset Type is Required.";
                    error = true;
                }
                if (!self.estimate_cost || self.estimate_cost == null || self.estimate_cost == "") {
                    self.estimate_cost_error_msg = "Estimated Cost is Required.";
                    error = true;
                }

            }


            //Sublet PO Type
            if (self.purchase_order_type.value == 'sublet_po') {
                var laborValFound = 0;
                var laborInd = 0;
                var partValFound = 0;
                var partInd = 0;

                /*for(var i = 0;i < self.chrows.length;i++) {
                    if (self.chrows[i] != undefined) {
                        if (self.chrows[i].charge_id != null) {
                            if (self.chrows[i].charge_id.text != "" && self.chrows[i].charge_id.text != null) {
                                if (self.chrows[i].charge_id.text.toLowerCase() == 'sublet labor') {
                                    if (self.chrows[i].amount == null || !self.chrows[i].amount || self.chrows[i].amount == 0) {
                                        laborValFound = 0;
                                    }else{
                                        laborValFound = 1;
                                    }
                                }
                                if (self.chrows[i].charge_id.text.toLowerCase() == 'sublet part') {
                                    if (self.chrows[i].amount == null || !self.chrows[i].amount || self.chrows[i].amount == 0) {
                                        partValFound = 0;
                                    }else{
                                        partValFound = 1;
                                    }
                                }
                            }
                        }
                    }
                }

                for(var i = 0;i < self.chrows.length;i++) {
                    self.chrows[i].charge_type_error_msg = "";
                    self.chrows[i].amount_error_msg = "";
                    if (self.chrows[i] != undefined) {
                        if (self.chrows[i].charge_id != null) {
                            if (self.chrows[i].charge_id.text != "" && self.chrows[i].charge_id.text != null) {

                                if (self.chrows[i].charge_id.text.toLowerCase() == 'sublet labor' || self.chrows[i].charge_id.text.toLowerCase() == 'sublet part') {
                                    if (self.chrows[i].charge_id.text.toLowerCase() == 'sublet labor') {
                                        if (laborValFound == 0 && partValFound == 0) {
                                            if (self.chrows[i].amount == null || !self.chrows[i].amount || self.chrows[i].amount == 0) {
                                                self.chrows[i].amount_error_msg = "Amount is Required.";
                                                error = true;
                                            }
                                        }
                                    }
                                    if (self.chrows[i].charge_id.text.toLowerCase() == 'sublet part') {
                                        if (laborValFound == 0 && partValFound == 0) {
                                            if (self.chrows[i].amount == null || !self.chrows[i].amount || self.chrows[i].amount == 0) {
                                                self.chrows[i].amount_error_msg = "Amount is Required.";
                                                error = true;
                                            }
                                        }
                                    }
                                }else{
                                    //Charge Selected but Value not Entered
                                    if (self.chrows[i].amount == null || !self.chrows[i].amount || self.chrows[i].amount == 0) {
                                        self.chrows[i].amount_error_msg = "Amount is Required.";
                                        error = true;
                                    }
                                }
                            }
                        }
                    }
                }*/
                //as per new changes
                for(var i = 0;i < self.chrows.length;i++) {
                    self.chrows[i].desc_error_msg = "";
                    self.chrows[i].amount_error_msg = "";
                    if (self.chrows[i].description == null || self.chrows[i].description == '') {
                        self.chrows[i].desc_error_msg = "Description is Required.";
                        error = true;
                    }
                    if (self.chrows[i].amount == null || !self.chrows[i].amount || self.chrows[i].amount == 0) {
                        self.chrows[i].amount_error_msg = "Amount is Required.";
                        error = true;
                    }
                }
            }

            // return;
            // if (self.purchase_order_type.value == "item" || self.purchase_order_type.value == "equipment") {
            //     if (parseInt(self.total) == 0) {
            //         self.$swal('',"PO Amount cannot be zero.",'info');
            //         error = true;
            //     }
            // }
            if (self.purchase_order_type.value == "equipment") {
                if (parseInt(self.total) == 0) {
                    self.$swal('',"PO Amount cannot be zero.",'info');
                    error = true;
                }
            }

            if (!error) {

                var path = window.location.pathname;
                var segments = path.split("/");
                // PR - For Purchase Order Charges
                var chargeIdsArr = [];
                var typesArr = [];
                var amountArr = [];
                var taxPercentageArr = [];
                var totalChargeArr = [];
                //check whether PO Amount matches with attached Vendor Invoice Amount
                if (self.poVendorInvoice != "") {
                    if (self.poVendorInvoice.sub_total != undefined) {
                        if (self.poVendorInvoice.sub_total != null) {
                            if (self.poVendorInvoice.sub_total && Number(self.sub_total) != self.poVendorInvoice.sub_total && segments[3]) {
                                if (!confirm('PO Amount does not match with Invoice Amount')) {
                                    return;
                                }
                            }
                        }
                    }
                }
                self.loading = true;

                if (segments[3]) {
                    $("#CreatePurchaseOrderBtn").val("Updating ...");
                    $("#CreatePurchaseOrderBtn").prop("disabled", true);
                    $("#cancelPurchaseOrderBtn").prop("disabled", true);
                } else {
                    if (flag == "Save and Continue") {

                        $("#createAndContinuePurchaseOrderBtn").val("Saving ...");
                        $("#CreatePurchaseOrderBtn").prop("disabled", true);
                        $("#createAndContinuePurchaseOrderBtn").prop("disabled", true);
                        $("#cancelPurchaseOrderBtn").prop("disabled", true);

                    } else if (flag == 'Process') {

                        $("#createAndProcessPOBtn").val("Saving ...");
                        $("#CreatePurchaseOrderBtn").prop("disabled", true);
                        $("#createAndContinuePurchaseOrderBtn").prop("disabled", true);
                        $("#cancelPurchaseOrderBtn").prop("disabled", true);
                    }else {

                        $("#CreatePurchaseOrderBtn").val("Saving ...");
                        $("#CreatePurchaseOrderBtn").prop("disabled", true);
                        $("#createAndContinuePurchaseOrderBtn").prop("disabled", true);
                        $("#cancelPurchaseOrderBtn").prop("disabled", true);
                    }
                }

                var fields = $("#PurchaseOrderForm").serializeArray();
                // alert(JSON.stringify(fields));

                fields.push({
                    name: "purchase_order_type",
                    value: self.purchase_order_type.value
                });
                fields.push({
                    name: "po_no",
                    value: self.po_number
                });
                // fields.push({name: "from_where", value: self.from_where.value});
                if (self.ordering_location_id == null) {
                    fields.push({
                        name: "ordering_location_id",
                        value: ""
                    });
                } else {
                    fields.push({
                        name: "ordering_location_id",
                        value: self.ordering_location_id.value
                    });
                }
                if (self.assigned_location_id == null) {
                    fields.push({
                        name: "assigned_location_id",
                        value: ""
                    });
                } else {
                    fields.push({
                        name: "assigned_location_id",
                        value: self.assigned_location_id.value
                    });
                }

                if (self.ship_to_location_id == null) {
                    fields.push({
                        name: "ship_to_location_id",
                        value: ""
                    });
                } else {
                    fields.push({
                        name: "ship_to_location_id",
                        value: self.ship_to_location_id.value
                    });
                }

                if (self.vendor_id == null) {
                    fields.push({
                        name: "vendor_id",
                        value: ""
                    });
                } else {
                    fields.push({
                        name: "vendor_id",
                        value: self.vendor_id.value
                    });
                }
                // if (self.customer_id == null) {
                //   fields.push({
                //     name: "customer_id",
                //     value: ""
                //   });
                // } else {
                //   fields.push({
                //     name: "customer_id",
                //     value: self.customer_id.value
                //   });
                // }
                // if (self.sales_person_id == null) {
                //     fields.push({
                //         name: "sales_person_id",
                //         value: ""
                //     });
                // } else {
                //     fields.push({
                //         name: "sales_person_id",
                //         value: self.sales_person_id.value
                //     });
                // }

                // if (self.status == null) {
                //     fields.push({
                //         name: "status",
                //         value: ""
                //     });
                // } else {
                //     fields.push({
                //         name: "status",
                //         value: self.status.value
                //     });
                // }
                //default status will be open and closed when create vendor invoice or receipt against it
                fields.push({
                    name: "status",
                    value: 'open'
                });

                if (self.vendor_estimate_id) {

                    fields.push({
                        name: "vendor_estimate_id",
                        value: self.vendor_estimate_id
                    });
                }

              if (parseInt(self.total) > 0 || parseInt(self.total) < 0) {
                var dataRowOne = self.rows
                if (self.fromCopyPage === 'YES') {
                  dataRowOne = dataRowOne.map(e => ({...e, purchase_order_item_id: 0}))
                }
                fields.push({
                  name: "purchaseOrderItems",
                  value: JSON.stringify(dataRowOne)
                });
              } else {
                fields.push({
                  name: "purchaseOrderItems",
                  value: []
                });
              }

                if(self.purchase_order_type.value == 'equipment-osr') {
                    fields.push({
                        name: "equipmentPOReadingItems",
                        value: JSON.stringify(self.eqp_po_rows)
                    });

                    console.log("osr_asset_pool == ", self.osr_asset_pool);
                    if(self.osr_asset_pool != null && self.osr_asset_pool != '' && self.osr_asset_pool.value != '') {
                      fields.push({
                          name: "asset_pool",
                          value: self.osr_asset_pool.value
                      });
                    }


                    console.log("vehicle_type == ", self.vehicle_type);
                    if(self.vehicle_type != null && self.vehicle_type != ''
                    && self.vehicle_type.value != '') {
                      fields.push({
                          name: "vehicle_type",
                          value: self.vehicle_type.value
                      });
                    }


                    if(self.estimate_cost != null && self.estimate_cost != '') {
                      fields.push({
                          name: "estimate_cost",
                          value: self.removeFormat(self.estimate_cost)
                      });
                    }

                    console.log("vehicle_manufacturer_id == ", self.vehicle_manufacturer_id);
                    if(self.vehicle_manufacturer_id != null && self.vehicle_manufacturer_id != ''
                    && self.vehicle_manufacturer_id.value != '') {
                      fields.push({
                          name: "vehicle_manufacturer_id",
                          value: self.vehicle_manufacturer_id.value
                      });
                    }

                    console.log("vehicle_model_id == ", self.vehicle_model_id);
                    if(self.vehicle_model_id != null && self.vehicle_model_id != ''
                    && self.vehicle_model_id.value != '') {
                      fields.push({
                          name: "vehicle_model_id",
                          value: self.vehicle_model_id.value
                      });
                    }
                }

              if (self.chrows[0].charge_id != null) {
                var dataChrowsOne = self.chrows
                if (self.fromCopyPage === 'YES') {
                  dataChrowsOne = dataChrowsOne.map(e => ({...e, purchase_order_item_id: 0}))
                }

                fields.push({
                  name: "chargesItem",
                  value: JSON.stringify(dataChrowsOne)
                });
              } else {
                if (self.purchase_order_type.value == "sublet_po") {
                  var dataChrowsTwo = self.chrows
                  if (self.fromCopyPage === 'YES') {
                    dataChrowsTwo = dataChrowsTwo.map(e => ({...e, purchase_order_item_id: 0}))
                  }
                  fields.push({
                    name: "chargesItem",
                    value: JSON.stringify(dataChrowsTwo)
                  });
                } else {
                  fields.push({
                    name: "chargesItem",
                    value: []
                  });
                }
              }

                fields.push({
                    name: "amount",
                    value: self.removeFormat(self.amount)
                });
                fields.push({
                    name: "fieldFlag",
                    value: flag
                });
                fields.push({
                    name: "id",
                    value: segments[3]
                });
                fields.push({
                    name:'woItems',
                    value:self.woiId
                })

                fields.push({
                    name:'work_order',
                    value:self.work_oid
                })

                fields.push({
                    name:'requisition_id',
                    value:self.reqId
                })

                //save and process po while create
                if (flag == 'Process' || flag == 'Invoice') {
                    fields.push({
                        name:'is_process',
                        value:"yes"
                    })
                }else{
                    fields.push({
                        name:'is_process',
                        value:"no"
                    })
                }

                // console.log(fields);
                $.ajax({
                    url: process.env.ROOT_API + "/vendor-purchase-order/create",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {

                        self.loading = false;
                        if (segments[3]) {
                            $("#CreatePurchaseOrderBtn").val("Update");
                            $("#CreatePurchaseOrderBtn").prop("disabled", false);
                            $("#cancelPurchaseOrderBtn").prop("disabled", false);
                        } else {

                            if (flag == "Save and Continue") {

                                $("#createAndContinuePurchaseOrderBtn").val("Save and Continue");
                                $("#CreatePurchaseOrderBtn").prop("disabled", false);
                                $("#createAndContinuePurchaseOrderBtn").prop("disabled", false);
                                $("#cancelPurchaseOrderBtn").prop("disabled", false);

                            } else if (flag == 'Process') {

                                $("#createAndProcessPOBtn").val("Save and Process");
                                $("#CreatePurchaseOrderBtn").prop("disabled", false);
                                $("#createAndContinuePurchaseOrderBtn").prop("disabled", false);
                                $("#cancelPurchaseOrderBtn").prop("disabled", false);
                            }else {

                                $("#CreatePurchaseOrderBtn").val("Save");
                                $("#CreatePurchaseOrderBtn").prop("disabled", false);
                                $("#createAndContinuePurchaseOrderBtn").prop("disabled", false);
                                $("#cancelPurchaseOrderBtn").prop("disabled", false);

                            }
                        }
                        if (data.code == 201 && data.status == 'unit_exist'){
                            self.unit_error_msg = data.content;
                            self.errorValidationFocus();
                            return;
                        }
                        if (data.code == 201 && data.status == 'vin_exist'){
                            self.vin_error_msg = data.content;
                            self.errorValidationFocus();
                            return;
                        }
                        if (data.status == 'quantity' && data.content){

                            self.rows[data.content].quantity_error_msg = 'Quantity should be same or greater than Approved Order`s Quantity';
                            return;
                        }
                        if (data.status == "success") {

                            self.showCharges = false;

                            if (flag == "Save and Continue") {

                                $("#PurchaseOrderForm").trigger("reset");
                                self.po_number = "";

                                self.purchase_order_type = {
                                    value: "item",
                                    text: "Item"
                                };
                                self.order_date = "";
                                self.due_date = "";
                                self.ordering_location_id = null;
                                self.assigned_location_id = null;
                                self.ship_to_location_id = null;
                                self.delivery_date = "";
                                self.customer_id = null;
                                // self.sales_person_id = null;
                                self.vendor_id = null;
                                self.attention = "";
                                self.notes = "";
                                self.model_code = "";
                                self.vehicle_type_code = "";
                                self.status = {
                                    value: "open",
                                    text: "Open"
                                };
                                self.rows = [];
                                // self.chargesArr = []; //empty array for section rates

                                self.rows.push({
                                    purchase_order_item_id: 0,
                                    model_code: null,
                                    model_error_msg: "",
                                    year: "",
                                    year_error_msg: "",
                                    quantity: 0,
                                    quantityEdit: true,
                                    quantity_error_msg: "",
                                    asset_pool_id: null,
                                    asset_pool_error_msg: "",
                                    unit_price: 0,
                                    unit_priceEdit: true,
                                    unit_price_error_msg: "",
                                    tax_percentage: 0,
                                    tax_percentage_error_msg: "",
                                    tax_amount: 0,
                                    tax_amount_error_msg: "",
                                    amount: 0,
                                    part: null,
                                    desc_error_msg:'',
                                    part_error_msg: "",
                                    gl_account_id:null,
                                    account_error_msg:'',
                                    measurement_unit_id:null,
                                    vehicle_id:null
                                });

                                // self.chargesArr.push({
                                //     charge_id: 0,
                                //     type: null,
                                //     amount: 0,
                                //     tax_percentage: 0,
                                //     total_charge: 0,
                                //     type_error_msg: "",
                                //     amount_error_msg: "",
                                //     tax_percentage_error_msg: "",
                                //     total_charge_error_msg: ""
                                // })

                                self.chrows.push({
                                    purchase_order_item_id: 0,
                                    charge_id: null,
                                    charge_type_error_msg: "",
                                    quantity: 0,
                                    quantity_error_msg: "",
                                    unit_price: 0,
                                    unit_price_error_msg: "",
                                    amount: 0,
                                    amountEdit: true,
                                    description:"",
                                    desc_error_msg:"",
                                    disableChargeSelect:false,
                                    amount_error_msg:"",
                                    vehicle_id:"",
                                    wo_item_id:""
                                });


                                self.sub_total = 0;
                                self.sub_total.toFixed(2);

                                self.total_tax = 0;
                                self.total_tax.toFixed(2);

                                self.total = 0;
                                self.showTotalSummary = false;

                            }else if(flag == 'Send with item' || flag == 'Send without item'){

                                var url = '&poId='+data.content.id+'&flag='+flag+'&from=Po';

                                self.$router.push({ name: 'PurchaseOrderPreview', query: { data : btoa(url) }});

                             } else if (flag == "Invoice") {
                                 var url = '&id=' + data.content.id + '&type=' + data.content.type;
                            //    self.$router.push("/vendor-invoice/create?id=" + data.content.id);
                                // self.$router.push({ name: 'BillCreate', query: { data : btoa(url) }});
                                self.$router.push({ name: 'RecordReceipt', query: { data : btoa(url) }});


                            } else {
                                if (self.$route.params.from != undefined && self.$route.params.from == 'woView') {
                                    self.$router.push({name: 'WorkOrderView',params:{id:self.$route.params.woId}});
                                }else{
                                    if ( window.location.search == "?from=asset" ) {
                                        self.$router.push("/vendor-purchase-order/view/" + data.content.id +"?from=asset");
                                    }else if(self.fromWoView){
                                        self.$router.push("/vendor-purchase-order/view/" + data.content.id +"?from=wo-"+self.work_oid);
                                    } else {
                                        self.$router.push("/vendor-purchase-order/view/" + data.content.id);
                                    }
                                }

                            }

                        } else if(data.status == "error-validat" && data.code == 201){
                            $(".alert-warning").removeClass("hide");
                            $("#errorMsg").html("");
                            $("#errorMsg").html(data.content);
                            $(".alert-warning").addClass("show");

                        } else {
                            if (data.content.length > 0) {
                                var err = "";
                                for (var i = 0; i < data.content.length; i++) {
                                    err += data.content[i] + "<br>";
                                }
                                $("#errorMsg").html(err);
                                $(".alert-warning").toggleClass("show");
                                setTimeout(function () {
                                    $(".alert-warning").removeClass("show");
                                    $(".alert-warning").addClass("hide");
                                }, 10000);
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (segments[3]) {
                            $("#CreatePurchaseOrderBtn").val("Update");
                            $("#CreatePurchaseOrderBtn").prop("disabled", false);
                            $("#cancelPurchaseOrderBtn").prop("disabled", false);
                        } else {

                            if (flag == "Save and Continue") {

                                $("#PurchaseOrderForm").trigger("reset");
                                $("#createAndContinuePurchaseOrderBtn").val("Save and Continue");
                                $("#CreatePurchaseOrderBtn").prop("disabled", false);
                                $("#createAndContinuePurchaseOrderBtn").prop("disabled", false);
                                $("#cancelPurchaseOrderBtn").prop("disabled", false);

                            } else if (flag == 'Process') {

                                $("#createAndProcessPOBtn").val("Save and Process");
                                $("#CreatePurchaseOrderBtn").prop("disabled", false);
                                $("#createAndContinuePurchaseOrderBtn").prop("disabled", false);
                                $("#cancelPurchaseOrderBtn").prop("disabled", false);

                            }else {

                                $("#CreatePurchaseOrderBtn").val("Save");
                                $("#CreatePurchaseOrderBtn").prop("disabled", false);
                                $("#createAndContinuePurchaseOrderBtn").prop("disabled", false);
                                $("#cancelPurchaseOrderBtn").prop("disabled", false);

                            }
                        }
                        self.generateStatusCodeMessage(jqXHR,true,'vendor-po-create')

                    }
                });
            }else{
                self.errorValidationFocus();
            }
        },
        loadPurchaseOrder() {
            var self = this;
            var id = '';
            var path = window.location.pathname;
            var segments = path.split("/");

            if(self.$route.params.copy_id != undefined){
              id = self.$route.params.copy_id;
            }else{
              id = segments[3];
            }

            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/purchaseorder/" + id,
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    console.log(data);

                    if (data.status == "success") {

                        self.isEdit = true;
                        if(self.$route.params.copy_id != undefined){
                          self.po_number = "";
                        }else{
                          self.po_number = data.content.po_no;
                        }
                        self.purchase_order_type = {
                            value: data.content.type,
                            text: self.titleCase(data.content.type)
                        };
                        if (data.content.type == "equipment-osr") {
                          // self.loadVehicleSearchData();
                          self.loadFieldData(['vehicleType', 'equipment-osr-asset-pool', 'vehicle_manufacturer' ]);
                          if(data.content.vehicleDetail != null && data.content.vehicleDetail != '') {
                            if(data.content.vehicleDetail.year != null && data.content.vehicleDetail.year != '') {
                              self.year = data.content.vehicleDetail.year;
                            }

                            if(data.content.vehicleDetail.vehi_pool_code != null && data.content.vehicleDetail.vehi_pool_code != '') {
                              self.osr_asset_pool = {
                                text: data.content.vehicleDetail.vehi_pool_code + " | " + data.content.vehicleDetail.vehi_pool_name,
                                value : data.content.vehicleDetail.vehi_pool_id
                              }
                            }

                            if(data.content.vehicleDetail.vehi_type_id != null && data.content.vehicleDetail.vehi_type_id != '') {
                              self.vehicle_type = {
                                text: data.content.vehicleDetail.vehi_type_name + " | " + data.content.vehicleDetail.vehi_type_code,
                                value : data.content.vehicleDetail.vehi_type_id,
                                vtCode: data.content.vehicleDetail.vehi_type_code
                              }
                            }

                            if(data.content.vehicleDetail.manufacturer_id != null && data.content.vehicleDetail.manufacturer_id != '') {
                              self.vehicle_manufacturer_id = {
                                text: data.content.vehicleDetail.manufacturer_name + " (" + data.content.vehicleDetail.manufacturer_code + ")",
                                value : data.content.vehicleDetail.manufacturer_id
                              }
                            }

                            if(data.content.vehicleDetail.model_id != null && data.content.vehicleDetail.model_id != '') {
                              self.vehicle_model_id = {
                                text: data.content.vehicleDetail.model_name + " (" + data.content.vehicleDetail.model_code + ")",
                                value : data.content.vehicleDetail.model_id
                              }
                            }

                            self.estimate_cost = self.amountFormat(data.content.total);

                            if(data.content.vehicleDetail.year != null && data.content.vehicleDetail.year != '') {
                              self.year = data.content.vehicleDetail.year;
                            }
                            if(data.content.vehicleDetail.vin != null && data.content.vehicleDetail.vin != '') {
                              self.vin = data.content.vehicleDetail.vin;
                            }
                            if(data.content.vehicleDetail.unit_no != null && data.content.vehicleDetail.unit_no != '') {
                              self.unit = data.content.vehicleDetail.unit_no;
                            }
                            if(data.content.vehicleDetail.customer_unit_no != null && data.content.vehicleDetail.customer_unit_no != '') {
                              self.vendorUnit = data.content.vehicleDetail.customer_unit_no;
                            }

                          }

                        }
                        if (data.content.type == "sublet_po") {
                            self.purchase_order_type = {
                                value: data.content.type,
                                text: "Sublet PO"
                            };
                        }
                        //if po type is equipment then only mso charges will be loaded
                        if (data.content.type == 'equipment') {
                            self.chargesArr = [];
                            for(var i = 0;i < self.defaultChargesArr.length;i++){
                                if (self.defaultChargesArr[i].identifier == "DMVELECFIL" ||
                                    self.defaultChargesArr[i].identifier == "MSOTITLEFEE" ||
                                    self.defaultChargesArr[i].identifier == "licensing_fee"){
                                    self.chargesArr.push(self.defaultChargesArr[i]);
                                }
                            }
                        }else{
                            self.chargesArr = [];
                            for(var i = 0;i < self.defaultChargesArr.length;i++){
                                self.chargesArr.push(self.defaultChargesArr[i]);
                            }
                        }
                        //disable purchase order type drop down
                        self.disablePurchaseOrderTypeField = true;

                        if (data.content.type == "item" || data.content.type == "sublet_po" || data.content.type == "misc") {
                            self.showItemFields = true;
                        } else {
                            self.showItemFields = false;
                        }
                        self.order_date = data.content.order_date;
                        self.due_date = data.content.due_date;
                        self.delivery_date = data.content.delivery_date;
                        self.attention = data.content.attention;
                        self.notes = data.content.notes;
                        self.status = {
                            value: data.content.status,
                            text: self.titleCase(data.content.status)
                        };
                        if (data.content.assigned_loc_id == null) {
                            self.assigned_location_id = null;
                        } else {
                            self.assigned_location_id = {
                                value: data.content.assigned_loc_id,
                                text: self.titleCase(data.content.assigned_loc_name + " (" + data.content.assigned_loc_code +
                                    ")")
                            };
                        }

                        if (data.content.ordering_loc_id == null) {
                            self.ordering_location_id = null;
                        } else {
                            self.ordering_location_id = {
                                value: data.content.ordering_loc_id,
                                text: self.titleCase(data.content.ordering_loc_name + " (" + data.content.ordering_loc_code +
                                    ")")
                            };
                        }

                        if (data.content.ship_loc_id == null) {
                            self.ship_to_location_id = null;
                        } else {
                            self.ship_to_location_id = {
                                value: data.content.ship_loc_id,
                                text: self.titleCase(data.content.ship_loc_name + " (" + data.content.ship_loc_code + ")")
                            };
                        }

                        if ((data.content.cust_id) != null) {
                            var name = (data.content.cust_name != null) ? data.content.cust_name : "";
                            var code = (data.content.cust_code != null) ? data.content.cust_code : "";

                            self.customer_id = {
                                value: data.content.cust_id,
                                text: self.titleCase(name + " (" + code + ")")
                            };
                        } else {
                            self.customer_id = null;
                        }

                        if (data.content.vID == null) {
                            self.vendor_id = null;
                        } else {
                            self.vendor_id = {
                                value: data.content.vID,
                                text: self.titleCase(data.content.vName + " (" + data.content.vCode + ")")
                            };
                        }

                        self.showCharges = true;
                        self.sub_total = data.content.sub_total;
                        self.total_tax = data.content.total_tax;
                        self.total = data.content.total;
                        self.amount = data.content.total;
                        console.log("self.amount =-==" , self.amount);
                        if (data.content.po_vendor_invoice != undefined) {
                            if (data.content.po_vendor_invoice.id != undefined) {
                                self.poVendorInvoice = data.content.po_vendor_invoice;
                            }
                        }
                        if (self.purchase_order_type.value == 'sublet_po') {
                            self.showTotalSummary = true;
                        }
                        // self.bill_number = data.content.bill_number;
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'vendor-po-load')
                }
            });
        },
        loadPurchaseOrderItem() {
            var self = this;
            var id = '';
            var path = window.location.pathname;
            var segments = path.split("/");
            if(self.$route.params.copy_id != undefined){
              id = self.$route.params.copy_id;
            }else{
              id = segments[3];
            }

            let reverse = 0;
            if(self.$route.params.reverse_po != undefined){
                reverse = self.$route.params.reverse_po;
            }

            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/vendor-purchase-order/items/" + id + '?reverse=' +reverse,
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;

                    if (data.status == "success") {

                        self.rows = [];
                        self.chrows = [];
                        var subletFoundArr = [];
                        var itemArr = [];
                        var vendor_po_type = "";
                        if (data.content.length >= 1) {
                            for (var i = 0; i < data.content.length; i++) {
                                vendor_po_type = data.content[i].vendor_po_type;
                                if (data.content[i].charge_id == null){
                                    var itemId = null;
                                    if (data.content[i].item_id != null) {
                                        var warehouse = '';
                                        if (data.content[i].warehouse != undefined){
                                            warehouse = 'WH '+data.content[i].warehouse;
                                        }
                                        var rsb = '';
                                        if (data.content[i].row != undefined){
                                            if (data.content[i].row == null){
                                                data.content[i].row = '';
                                            }
                                            if (data.content[i].shelf == null){
                                                data.content[i].shelf = '';
                                            }
                                            if (data.content[i].bin == null){
                                                data.content[i].bin = '';
                                            }
                                            rsb = data.content[i].row+'/'+data.content[i].shelf+'/'+data.content[i].bin;
                                        }
                                        itemId = {
                                            value: data.content[i].item_id,
                                            text: data.content[i].iCode + " | " + data.content[i].iName + ' | '+warehouse + ' | '+rsb,
                                            bin_id:data.content[i].bin_mapper_id != undefined ? data.content[i].bin_mapper_id : null,
                                            warehouse_id:data.content[i].warehouse_id != undefined ? data.content[i].warehouse_id : null
                                        };
                                    }
                                    var unitName = "";
                                    if (data.content[i].unit_no != null && data.content[i].unit_no != "") {
                                        unitName = data.content[i].unit_no;
                                    }
                                    if (data.content[i].unit_name != null && data.content[i].unit_name != "") {
                                        unitName += " | ";
                                        unitName += data.content[i].unit_name;
                                    }

                                    self.rows.push({
                                        purchase_order_item_id: data.content[i].id,
                                        model_code: {
                                            value: data.content[i].model_id,
                                            text: self.titleCase(data.content[i].vmodelsCode + " | " + data.content[i].vmodelsName)
                                        },
                                        model_error_msg: "",
                                        description: data.content[i].description,
                                        year: data.content[i].year,
                                        year_error_msg: "",
                                        quantity: self.amountFormat(data.content[i].quantity,3),
                                        quantityEdit: true,
                                        quantity_error_msg: "",
                                        asset_pool_id: {
                                            value: data.content[i].asset_pool_id,
                                            text: self.titleCase(data.content[i].vpoolCode + " | " + data.content[i].vpoolDesc)
                                        },
                                        asset_pool_error_msg: "",

                                        unit_price:self.amountFormat(data.content[i].unit_price,3),
                                        unit_priceEdit: true,
                                        unit_price_error_msg: "",
                                        tax_percentage: data.content[i].tax_percentage,
                                        tax_percentage_error_msg: "",
                                        tax_amount: data.content[i].tax_amount,
                                        tax_amount_error_msg: "",
                                        amount:self.amountFormat(data.content[i].total,3),
                                        part: itemId,
                                        desc_error_msg:"",
                                        part_error_msg: "",
                                        gl_account_id:(data.content[i].gl_account_id != null && data.content[i].gl_account_id != undefined) ? {text:data.content[i].glCode+' | '+data.content[i].glDesc,value:data.content[i].gl_account_id}:null,
                                        account_error_msg:'',
                                        measurement_unit_id:(data.content[i].measurement_unit_id != null && data.content[i].measurement_unit_id != undefined) ? {text:data.content[i].uomDesc+' ('+data.content[i].uomCode+')',value:data.content[i].measurement_unit_id}:null,
                                        vehicle_id: (data.content[i].item_vehicle_id != undefined && data.content[i].item_vehicle_id != null && data.content[i].item_vehicle_id != '')?{value: data.content[i].item_vehicle_id, text: self.titleCase(unitName)}:null,
                                    });

                                    if (data.content[i].vendor_po_type == "sublet_po") {
                                        itemArr.push({
                                            purchase_order_item_id: data.content[i].id,
                                            quantity: data.content[i].quantity,
                                            quantity_error_msg: "",
                                            unit_price: data.content[i].unit_price,
                                            unit_price_error_msg: "",
                                            amount: data.content[i].total,
                                            amountEdit:false,
                                            charge_id:null,
                                            description:data.content[i].description,
                                            desc_error_msg:"",
                                            disableChargeSelect:true,
                                            amount_error_msg:"",
                                            charge_type_error_msg: "",
                                            vehicle_id: (data.content[i].item_vehicle_id != undefined && data.content[i].item_vehicle_id != null && data.content[i].item_vehicle_id != '')?{value: data.content[i].item_vehicle_id, text: self.titleCase(unitName)}:null,
                                            wo_item_id:(data.content[i].wo_item_id != undefined && data.content[i].wo_item_id != null && data.content[i].wo_item_id != '')?data.content[i].wo_item_id:"",
                                        });
                                    }

                                } else {

                                    var chargeId = null;
                                    if (data.content[i].charge_id != null) {
                                        chargeId = {
                                            value: data.content[i].charge_id,
                                            text: data.content[i].charge_name
                                        };
                                    }

                                    //Sublet Labor and Sublet Part
                                    if (data.content[i].vendor_po_type == "sublet_po") {

                                        subletFoundArr.push(data.content[i].charge_identifier);

                                        itemArr.push({
                                            purchase_order_item_id: data.content[i].id,
                                            quantity: data.content[i].quantity,
                                            quantity_error_msg: "",
                                            unit_price: data.content[i].unit_price,
                                            unit_price_error_msg: "",
                                            amount: data.content[i].total,
                                            amountEdit: true,
                                            charge_id: chargeId,
                                            description:data.content[i].description,
                                            desc_error_msg:"",
                                            disableChargeSelect:(data.content[i].charge_identifier != undefined
                                             && (data.content[i].charge_identifier == "sublet_labor" || data.content[i].charge_identifier == "sublet_part"))?true:false,
                                            amount_error_msg:"",
                                            charge_type_error_msg: "",
                                        });

                                    } else {

                                        self.chrows.push({
                                            purchase_order_item_id: data.content[i].id,
                                            quantity: data.content[i].quantity,
                                            quantity_error_msg: "",
                                            unit_price:(data.content[i].vendor_po_type == "item")?self.amountFormat(data.content[i].unit_price,3):data.content[i].unit_price,
                                            unit_price_error_msg: "",
                                            amount:(data.content[i].vendor_po_type == "item")?self.amountFormat(data.content[i].total,3):data.content[i].total,
                                            amountEdit: true,
                                            charge_id: chargeId,
                                            description:"",
                                            desc_error_msg:"",
                                            disableChargeSelect:false,
                                            amount_error_msg:"",
                                            charge_type_error_msg: "",
                                            vehicle_id:"",
                                            wo_item_id:""
                                        })
                                    }

                                }

                            }

                            if (vendor_po_type == 'sublet_po') {

                                console.log(itemArr);
                                self.rows = [];
                                self.chrows = [];
                                for(var i = 0;i<itemArr.length;i++) {
                                    self.chrows.push(itemArr[i]);
                                }

                            }else{
                                if (!self.chrows || self.chrows.length == 0){
                                    self.chrows.push({
                                        purchase_order_item_id: 0,
                                        charge_id: null,
                                        charge_type_error_msg: "",
                                        quantity: 0,
                                        quantity_error_msg: "",
                                        unit_price: 0,
                                        unit_price_error_msg: "",
                                        amount: 0,
                                        amountEdit: true,
                                        description:"",
                                        desc_error_msg:"",
                                        disableChargeSelect:false,
                                        amount_error_msg:"",
                                        vehicle_id:"",
                                        wo_item_id:""
                                    });
                                }
                            }
                        } else {
                            setTimeout(function () {
                            if (self.purchase_order_type.value == 'sublet_po') {

                                self.chrows = [];
                                self.rows = [];

                            }else{
                                console.log("ELSE11");
                                self.rows.push({
                                    purchase_order_item_id: 0,
                                    model_code: "",
                                    model_error_msg: "",
                                    year: "",
                                    year_error_msg: "",
                                    quantity: 0,
                                    quantityEdit: true,
                                    quantity_error_msg: "",
                                    asset_pool_id: "",
                                    asset_pool_error_msg: "",
                                    unit_price: 0,
                                    unit_priceEdit: true,
                                    unit_price_error_msg: "",
                                    tax_percentage: 0,
                                    tax_percentage_error_msg: "",
                                    tax_amount: 0,
                                    tax_amount_error_msg: "",
                                    amount: 0,
                                    description: "",
                                    part: "",
                                    desc_error_msg:"",
                                    part_error_msg: "",
                                    vehicle_id:null
                                });

                                self.chrows.push({
                                    purchase_order_item_id:0,
                                    quantity: 0,
                                    quantity_error_msg: "",
                                    unit_price: 0,
                                    unit_price_error_msg: "",
                                    amount: 0,
                                    amountEdit: true,
                                    charge_id: null,
                                    description:"",
                                    desc_error_msg:"",
                                    disableChargeSelect:false,
                                    amount_error_msg:"",
                                    charge_type_error_msg:"",
                                    vehicle_id:"",
                                    wo_item_id:""
                                })
                            }
                            }, 200);

                        }
                        if (vendor_po_type == 'sublet_po') {
                            self.showTotalSummary = true;
                        }else{
                            if ( self.rows.length > 1) {
                                self.showTotalSummary = true;
                            }else{
                                self.showTotalSummary = false;
                            }
                        }

                        if(data.hasOwnProperty('readings')) {
                          if(data.readings.length > 0) {
                            self.eqp_po_rows = [];
                            for (var i = 0; i < data.readings.length; i++) {
                              var idx = self.sectionArr.findIndex(obj => obj == data.readings[i].section_name);
                              if (idx != -1) {
                                self.sectionArr.splice(idx, 1);
                              }
                              self.eqp_po_rows.push({
                                  id: data.readings[i].id,
                                  section_type: data.readings[i].section_name,
                                  section_type_error_msg: '',
                                  reading_date: moment(data.readings[i].reading_date).format('MM/DD/YYYY hh:mm:ss a'),
                                  reading_date_error_msg: '',
                                  reading: data.readings[i].reading,
                                  reading_error_msg: '',
                              });
                            }
                          }
                        }

                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'vendor-po-load-item')
                }
            });
        },

        titleCase(str) {
            if (str == null) {
                return;
            } else {
                var value = str.toString()
                return value.charAt(0).toUpperCase() + value.slice(1)
            }
        },
        loadEstimateItem: function(estId){

            var self = this;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/vendor-estimate-item-po",
                type: "GET",
                headers: this.ajxHeaders,
                data:{
                    est_id:estId
                },
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    // console.log(data);

                    if (data.status == "success") {

                        self.rows = [];
                        //as per new change
                        var laborAmount = 0;
                        var partAmount = 0;
                        var chargeAmount = 0;
                        var labordisable = false;
                        var partdisable = false;
                        if (data.content.labor_amount != undefined) {
                            laborAmount = data.content.labor_amount;
                        }

                        if (data.content.part_amount != undefined) {
                            partAmount = data.content.part_amount;
                        }
                        if(data.content.part_amount != undefined && data.content.part_amount != 0){
                            partdisable = true;
                        }
                        if(data.content.labor_amount != undefined && data.content.labor_amount != 0){
                            labordisable = true;
                        }
                        self.chrows = [];
                        var sublet_labor = null;
                        var sublet_part = null;
                        var obj = self.chargesArr;
                        $.each(obj, function (key, chargevalue) {
                            if (chargevalue.identifier == 'sublet_labor') {
                                sublet_labor = {
                                    value: chargevalue.value,
                                    text: chargevalue.text,
                                };
                            }
                            if (chargevalue.identifier == 'sublet_part') {
                                sublet_part = {
                                    value: chargevalue.value,
                                    text: chargevalue.text,
                                };
                            }
                        });

                        //Sublet Labor
                        self.chrows.push({
                            purchase_order_item_id:0,
                            quantity: 1,
                            quantity_error_msg: "",
                            unit_price: 0,
                            unit_price_error_msg: "",
                            amount: laborAmount,
                            amountEdit: true,
                            charge_id:(sublet_labor != undefined && sublet_labor != null)?sublet_labor:{text:"Sublet Labor",value:"sublet_labor"},
                            description:"",
                            desc_error_msg:"",
                            disableChargeSelect:labordisable,
                            amount_error_msg:"",
                            charge_type_error_msg:"",
                            vehicle_id:"",
                            wo_item_id:""
                        });
                        //Sublet Part
                        self.chrows.push({
                            purchase_order_item_id:0,
                            quantity: 1,
                            quantity_error_msg: "",
                            unit_price: 0,
                            unit_price_error_msg: "",
                            amount: partAmount,
                            amountEdit: true,
                            charge_id:(sublet_part != undefined && sublet_part != null)?sublet_part:{text:"Sublet Part",value:"sublet_part"},
                            description:"",
                            desc_error_msg:"",
                            disableChargeSelect:partdisable,
                            amount_error_msg:"",
                            charge_type_error_msg:"",
                            vehicle_id:"",
                            wo_item_id:""
                        });
                        self.chrows.push({
                            purchase_order_item_id: 0,
                            charge_id: null,
                            charge_type_error_msg: "",
                            quantity: 1,
                            quantity_error_msg: "",
                            unit_price: 0,
                            unit_price_error_msg: "",
                            amount: chargeAmount.toFixed(2),
                            amountEdit: true,
                            description:"",
                            desc_error_msg:"",
                            disableChargeSelect:false,
                            amount_error_msg:"",
                            vehicle_id:"",
                            wo_item_id:""
                        });
                        for (var i = 0; i < self.chrows.length; i++) {
                            self.calculateChargeAmount('',i);
                        }
                        self.showTotalSummary = true;

                        // self.calculateTaxSubTotal();
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'vendor-po-load-estimate-item')
                }
            });

        },
        calculateAmount($event, index) {
            // alert(index);
            var self = this;
            if (self.rows[index].quantity == 0 || self.rows[index].unit_price == 0 || self.rows[index].quantity == null ||
                self.rows[index].unit_price == null) {
                self.rows[index].tax_percentage = 0;
            }
            self.calculateTaxSubTotal();

        },
        calculateTaxSubTotal() {

            var self = this;
            var totalAmount = 0;
            for (var i = 0; i < self.rows.length; i++) {
                //if text has value negative
                if (self.rows[i].quantity == "-" || self.rows[i].unit_price == "") {
                    self.rows[i].amount = parseFloat("0");
                    continue;
                }

                if( String(self.rows[i].quantity).includes(':')){

                    var quant = self.rows[i].quantity.split(':');
                    self.rows[i].quantity = quant[0];
                }


                console.log("CALC");

                self.rows[i].amount = self.removeFormat(self.rows[i].quantity) * self.removeFormat(self.rows[i].unit_price);
                self.rows[i].tax_amount = (parseFloat(self.rows[i].amount) * parseFloat(self.rows[i].tax_percentage)) / 100;
                // alert(self.rows[i].tax_amount);

                if ( self.rows[i].tax_amount) {

                    self.rows[i].amount = parseFloat(self.rows[i].amount) + parseFloat(self.rows[i].tax_amount);

                } else {
                    self.rows[i].amount = parseFloat(self.rows[i].amount);
                }

                //self.rows[i].amount = self.rows[i].amount.toFixed(2);
                totalAmount += parseFloat(self.rows[i].amount);


                if(self.rows[i].amount > 999999.99 || self.rows[i].amount < -999999.99) {
                  self.rows[i].unit_priceEdit = false;
                  self.rows[i].quantityEdit = false;
                  self.rows[i].unit_price_error_msg = "Amount value exceed";
                } else {
                  self.rows[i].unit_priceEdit = true;
                  self.rows[i].quantityEdit = true;
                  self.rows[i].unit_price_error_msg = "";

                }

                if (self.purchase_order_type.value == "item") {
                    self.rows[i].amount = self.amountFormat(self.rows[i].amount,3);
                }

            }

            self.sub_total = "";
            //previous
            // self.sub_total = self.rows.reduce(function(prev, cur) {
            //     return prev + cur.amount;
            // }, 0);
            self.sub_total = self.getNum(self.rows.reduce(function (prev, cur) {

                return prev + (self.removeFormat(cur.quantity) * self.removeFormat(cur.unit_price));

                // if (self.purchase_order_type.value == "item") {

                //     return prev + (self.removeFormat(cur.quantity)) * self.removeFormat(cur.unit_price);

                // } else {
                //     return prev + (self.removeFormat(cur.quantity) * self.removeFormat(cur.unit_price));
                // }
            }, 0));
            console.log("sub_total 111 =", self.sub_total);

            self.total_tax = "";
            self.total_tax = self.rows.reduce(function (prev, cur) {
                return prev + parseFloat(cur.tax_amount);
            }, 0);

            var charges = 0;

            console.log("charge =", self.chrows);

            for (var k = 0; k < self.chrows.length; k++) {

                charges += self.removeFormat(self.chrows[k].amount);
                // if (self.chrows[k].amount != "") {
                //     charges += self.removeFormat(self.chrows[k].amount);

                // }else{
                //     charges +=  self.removeFormat(self.chrows[k].amount);
                // }

            }
            self.sub_total += self.getNum(charges);

            console.log("self.sub_total =", self.sub_total);

            if (self.$route.params.redirectFrom != undefined && self.$route.params.redirectFrom == 'AssetRequisition'){
              console.log("TOTAL ===" , totalAmount);
                self.amount = totalAmount;
            }

        },
        validateChRawInput(evt, index) {

          var self = this;
          if(self.chrows[index].unit_price > 999999.99) {
            self.chrows[index].unit_priceEdit = false;
          } else {
            self.chrows[index].unit_priceEdit = true;
          }

        },
        validateCHRowAmountInput(evt, index){
          var self = this;
          if(self.chrows[index].amount > 999999.99) {
            self.chrows[index].amountEdit = false;
          } else {
            self.chrows[index].amountEdit = true;
          }
        },
        enterValLine:function(evt, index) {
          var self = this;
          evt = (evt) ? evt : window.event;

          console.log("ENTER  ==", evt.target.name);
          self.chrows[index].amount = evt.target.value;
          self.chrows[index].amount = self.removeFormat(evt.target.value);
        },
        leaveFocusLine:function(evt, index) {
          var self = this;
          evt = (evt) ? evt : window.event;
          self.chrows[index].amount =  this.amountFormat(evt.target.value);
        },

        validateRawInput(evt, index) {
          var self = this;
          if(self.rows[index].unit_price > 999999.99) {
            self.rows[index].unit_priceEdit = false;
          } else {
            self.rows[index].unit_priceEdit = true;
          }

        },
        isNumberCheck: function (evt, index, type) {
          console.log("NUM CHECK == ", type);

            var self = this;
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && (charCode !== 46 || evt.target.value.indexOf(
                    '.') != -1)) {
                evt.preventDefault();
            } else {
              if(type == 'row-qty') {
                if(self.rows[index].quantityEdit) {
                  return true;
                } else {
                  evt.preventDefault();
                }
              } else if (type == 'row-price') {
                if(self.rows[index].unit_priceEdit) {
                  return true;
                } else {
                  evt.preventDefault();
                }
              } else if (type == 'chrow-price') {
                if(self.chrows[index].unit_priceEdit) {
                  return true;
                } else {
                  evt.preventDefault();
                }

              } else if (type == 'chrow-qty') {
                if(self.chrows[index].quantityEdit) {
                  return true;
                } else {
                  evt.preventDefault();
                }
              } else if (type == 'chrow-amount') {
                if(self.chrows[index].amountEdit) {
                  return true;
                } else {
                  evt.preventDefault();
                }
              }
                // return true;
            }
        },
        calculateChargeAmount:function(evt,index){
            var self = this;
            var amount = 0;
            var totalAmount = 0
            var charges = 0;
            if (self.purchase_order_type.value != 'sublet_po') {
                if (String(self.chrows[index].unit_price).includes(',')) {
                    self.chrows[index].amount = self.removeFormat(self.chrows[index].quantity) * self.removeFormat(self.chrows[index].unit_price);
                    var formatAmount = self.chrows[index].amount;
                    self.chrows[index].amount = self.amountFormat(formatAmount,3);
                }else{
                    self.chrows[index].amount = parseFloat(self.removeFormat(self.chrows[index].quantity) * self.removeFormat(self.chrows[index].unit_price));
                    var formatAmount = self.chrows[index].amount;
                    self.chrows[index].amount = self.amountFormat(formatAmount,3);
                }
            }else{
                self.chrows[index].unit_price = self.amountFormat(self.chrows[index].amount,3);
            }
            self.isDisableStore = false;

            if ( self.removeFormat(self.chrows[index].amount) > 9999999.99 ) {
              self.chrows[index].unit_priceEdit = false;
              self.chrows[index].quantityEdit = false;
              self.chrows[index].amountEdit = false;
              self.chrows[index].unit_price_error_msg = "Amount value exceed";
              self.chrows[index].amount_error_msg = "Amount value exceed";
              self.isDisableStore = true;
            } else {
              self.chrows[index].unit_priceEdit = true;
              self.chrows[index].quantityEdit = true;
              self.chrows[index].amountEdit = true;
              self.chrows[index].unit_price_error_msg = "";
              self.chrows[index].amount_error_msg = "";


            }

            for (var j = 0; j < self.rows.length; j++) {
                //if amount format is added in line item
                totalAmount += self.removeFormat(self.rows[j].amount);

            }

            for (var k = 0; k < self.chrows.length; k++) {
                charges += self.removeFormat(self.chrows[k].amount);
            }
            console.log(totalAmount+"=="+charges);
            var poTotal = totalAmount + charges;
            console.log("Total=="+poTotal);
            self.sub_total = self.amountFormat(poTotal,3);
            console.log("Total=="+self.sub_total);
            self.showTotalSummary = true;
        },
        getWorkOrderDataForPO(wo_id,itemId) {

            var self = this;
            var path = window.location.pathname;
            var segments = path.split("/");

            // var woItems = itemId.split(',');

            // let wo_id = (segments[3] != undefined) ? segments[3] : self.woId;
            //unbind jScrollPane
            setTimeout(function () {
                $(function () {
                    var pane = $('.comment-list-btm');
                    pane.jScrollPane();
                    var api = pane.data('jsp');
                    if (api != undefined) {
                        api.destroy();
                    }

                    //activity jScrollPane
                    var paneActivity = $('.activity-list-btm');
                    paneActivity.jScrollPane();
                    var apiActivity = paneActivity.data('jsp');
                    if (apiActivity != undefined) {
                        apiActivity.destroy();
                    }
                });
            }, 200);
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/get-workorder-items",
                type: "GET",
                headers: this.ajxHeaders,
                crossDomain: true,
                dataType: "json",
                data: {
                    work_order_id: wo_id,
                    wo_item_ids:itemId
                },
                success: function (data) {

                    if (data.code == 200) {

                        self.taskArr = [];
                        self.compArr = [];
                        self.laborArr = [];
                        self.commentArr = [];
                        self.laborHourArr = [];
                        self.activityArr = [];

                        if (data.content.item != undefined) {

                            if ( data.content.item[0] && data.content.item[0].vendorid){

                                self.vendor_id = {text:data.content.item[0].vendorname+' | '+data.content.item[0].vendorcode,value:data.content.item[0].vendorid};
                            }

                            self.rows = [];

                            if (data.content.item != undefined && data.content.item.length >= 1) {
                                for (var i = 0; i < data.content.item.length; i++) {
                                    self.rows.push({
                                        purchase_order_item_id: 0,
                                        model_code:null,
                                        model_error_msg: "",
                                        description: data.content.item[i].component_category_code+ ' | '+data.content.item[i].component_category_name+' , '+data.content.item[i].task_name+' | '+data.content.item[i].task_code,

                                        year_error_msg: "",
                                        quantity: 1,
                                        quantityEdit: true,
                                        quantity_error_msg: "",
                                        year:"",
                                        asset_pool_id: "",
                                        asset_pool_error_msg: "",
                                        unit_price: data.content.item[i].sublet_amount,
                                        unit_priceEdit: true,
                                        unit_price_error_msg: "",
                                        tax_percentage: 0,
                                        tax_percentage_error_msg: "",
                                        tax_amount: 0,
                                        tax_amount_error_msg: "",
                                        amount: data.content.item[i].sublet_amount,
                                        desc_error_msg:"",
                                        part_error_msg: "",
                                        part:"",
                                        gl_account_id:null,
                                        account_error_msg:'',
                                        measurement_unit_id:null,
                                        vehicle_id:null
                                    })
                                    self.calculateAmount('',i);
                                }
                                // self.calculateTaxSubTotal();
                            }
                            // setTimeout(function () {
                            //     self.CreatePurchaseOrder('');
                            // },1000);
                        }

                    } else if (data.code == 201) {

                        console.log('No line item is assigned with wo..')
                        self.addSetOfTask();

                    }
                },
                error: function (jqXHR, exception) {
                    self.Registerbtn = "Register";
                    self.generateStatusCodeMessage(jqXHR,true,'vendor-po-get-wo-for-po')

                }
            });
        },
        loadAssetRequisition() {

            var self = this;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/asset-requisition/" + self.reqId,
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    console.log(data);


                    if (data.status == "success") {
                        self.delivery_date = data.content.required_delivery_date;
                        self.purchase_order_type = {text:'Equipment',value:'equipment'};
                        // self.estimated_delivery_date = data.content.estimated_delivery_date;
                        if (data.content.assigned_loc_id == null) {
                            self.assigned_location_id = null;
                        } else {
                            self.assigned_location_id = {
                                value: data.content.assigned_loc_id,
                                text: self.titleCase(data.content.assigned_loc_name + " (" + data.content.assigned_loc_code +
                                    ")")
                            };
                        }

                        if (data.content.ordering_loc_id == null) {
                            self.ordering_location_id = null;
                        } else {
                            self.ordering_location_id = {
                                value: data.content.ordering_loc_id,
                                text: self.titleCase(data.content.ordering_loc_name + " (" + data.content.ordering_loc_code +
                                    ")")
                            };
                        }

                        if (data.content.ship_loc_id == null) {
                            self.ship_to_location_id = null;
                        } else {
                            self.ship_to_location_id = {
                                value: data.content.ship_loc_id,
                                text: self.titleCase(data.content.ship_loc_name + " (" + data.content.ship_loc_code + ")")
                            };
                        }

                        // if ((data.content.sales_id) != null) {
                        //     var firstname = (data.content.sales_firstname != null) ? data.content.sales_firstname : "";
                        //     var lastname = (data.content.sales_lastname != null) ? data.content.sales_lastname : "";
                        //     self.sales_person_id = {
                        //         value: data.content.sales_id,
                        //         text: self.titleCase(firstname + " " + lastname)
                        //     };
                        // } else {
                        //     self.sales_person_id = null;
                        // }

                        setTimeout(function(){

                            self.rows = [];

                            self.rows.push({
                                purchase_order_item_id: 0,
                                model_code: {
                                    value: data.content.modelId,
                                    text: self.titleCase(data.content.modelCode + " | " + data.content.modelName)
                                },
                                model_error_msg: "",
                                year: data.content.year,
                                year_error_msg: "",
                                quantity: data.content.quantity,
                                quantityEdit: true,
                                quantity_error_msg: "",
                                asset_pool_id: {
                                    value: data.content.poolId,
                                    text: self.titleCase(data.content.poolCode + " | " + data.content.poolName)
                                },
                                asset_pool_error_msg: "",
                                unit_price: data.content.unit_price,
                                unit_priceEdit: true,
                                unit_price_error_msg: "",
                                tax_percentage: 0,
                                tax_percentage_error_msg: "",
                                tax_amount: 0,
                                tax_amount_error_msg: "",
                                amount: 0,
                                description: data.content.description,
                                desc_error_msg: "",
                                part: null,
                                part_error_msg: "",
                                asset_requisition_id: data.content.id,
                                gl_account_id:null,
                                account_error_msg:'',
                                measurement_unit_id:null,
                                vehicle_id:null
                            });

                             self.calculateAmount('',0);
                        },400);
                        // self.calculateTaxSubTotal();
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'vendor-po-load-asset-reqisition')

                }
            });
        },
        onChargeSelect(event,index) {
            var self = this;
            if (self.chrows[index].charge_id != null && self.chrows[index].charge_id != "") {
                self.chrows[index].unit_price = self.amountFormat(self.chrows[index].charge_id.price,3);
                self.chrows[index].amount = self.amountFormat(self.chrows[index].charge_id.price,3);
            }else{
                self.chrows[index].unit_price = "";
                self.chrows[index].amount = "";
            }
            self.chrows[index].quantity = "1.000";
            self.calculateChargeAmount('',index);
        },
        enterUnitPrice:function(evt,index,type) {
            var self = this;
            evt = (evt) ? evt : window.event;
            if (type == "item-price"){

                self.rows[index].unit_price = self.removeFormat(evt.target.value);
                setTimeout(function(){
                    $("#unit_price"+index).trigger('select');
                },100);
            } else {
                self.chrows[index].unit_price = self.removeFormat(evt.target.value);
                setTimeout(function(){
                    $("#charge_price"+index).trigger('select');
                },100);
            }

        },
        leaveFocusUnitPrice:function(evt,index,type) {
            var self = this;
            evt = (evt) ? evt : window.event;
            if (type == "item-price" ) {

                self.rows[index].unit_price = self.amountFormat(self.rows[index].unit_price,3);

            } else if (type == "item-qty" ) {

                self.rows[index].quantity = self.amountFormat(self.rows[index].quantity,3);

            } else if ( type == "chrow-qty" ) {

                self.chrows[index].quantity = self.amountFormat(self.chrows[index].quantity,3);

            } else {

                self.chrows[index].unit_price = self.amountFormat(self.chrows[index].unit_price,3);

            }
        },
        onSearchAsset(search, loading) {
            var self = this;
            // use this in order to create new asset...
            if (search.length > 3) {
                loading(true);
                self.searchField(loading, search, 'vehicle');
            }
        },

        populatePrice:function(id,index){
            var self = this;
            self.ship_to_location_error_msg = '';
            if (self.ship_to_location_id == '' || self.ship_to_location_id == null || !self.ship_to_location_id.value){
                self.ship_to_location_error_msg = "Ship to location required";
            }
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/part-price",
                type: "GET",
                headers: this.ajxHeaders,
                data:{
                    id:id,
                    location:self.ship_to_location_id.value
                },
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {
                        self.rows[index].unit_price = self.amountFormat(data.content,3);
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'vendor-po-load-asset-reqisition')

                }
            });

        },
        changePOType:function(){
            var self = this;
            if (self.purchase_order_type.value && self.purchase_order_type.value == 'equipment-osr'){
                self.conTypeDisable = false;
            }else{
                self.conTypeDisable = true;
            }
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/VendorPurchaseOrderCreate.vue